<template>
  <div>
    <div class="showLazyLoad"
      v-if='showLazyLoad'>正在加载数据...</div>
    <div class="nonData"
      v-if='nonData'>暂时没有更多数据</div>
    <div class="loading"
      v-if="showLoading">
      <div>
        <img src="../../assets/images/loading.gif"
          alt="">
      </div>
    </div>
    <div class="headerWrapper">
      <i class="icon iconfont left"
        @click="goBack()">&#xe604;</i>
      <div class="header-center">
        <span
          class="contract-switch-arrow contract-switch-arrow-prev"
          :class="{ disabled: !canSwitchContract }"
          @click.stop="switchContract(-1)"
        >‹</span>
        <div class="contract-names">
          <div class="contract-cn">{{ contractNameCn }}</div>
          <div class="contract-en-line">
            <span class="contract-en">{{ contractNameEn }}</span>
            <span v-if="isDominantContract" class="dominant-badge">主</span>
          </div>
        </div>
        <span
          class="contract-switch-arrow contract-switch-arrow-next"
          :class="{ disabled: !canSwitchContract }"
          @click.stop="switchContract(1)"
        >›</span>
      </div>
      <i class="icon iconfont right"
        @click="order">&#xe624;</i>
      <i class="icon iconfont right2"
        @click="select(title)"
        v-html="selfContract2"></i>
    </div>
    <div class="top-wrapper"
      ref="two_top">
      <div class="top" ref="topBar">
        <div class="top-left">
          <i @click="changeIcon"
            class="icon iconfont"
            v-show="false"
            v-html="nowIcon"></i>
        </div>
        <div class="top-middle"
          ref="back"
          :style="topMiddleStyle"
          :class="{'c_grey':c_grey,'c_red':c_red,'c_green':c_green}">
          <div class="middle-first">
            {{newPrice}}
          </div>
          <div class="middle-two">
            <p>
              {{ranges}}
            </p>
            <p>
              {{limit}}%
            </p>
          </div>
        </div>
        <!-- :class="{'grey':item.latestPrice==item.lastSettlementPrice,'red':item.latestPrice>item.lastSettlementPrice,'green':item.latestPrice<item.lastSettlementPrice}" -->
        <div class="top-right"
          ref="topRight">
          <div class="right-content">
            <span class="rc-label">今　开</span>
            <span :class="{openColor:open_color,openColor2:open_color2}">{{open}}</span>
          </div>
          <div class="right-content">
            <span class="rc-label">成交量</span>
            <span>{{turnover}}</span>
          </div>
          <div class="right-content">
            <span class="rc-label">昨　结</span>
            <span>{{close}}</span>
          </div>
          <div class="right-content">
            <span class="rc-label">持仓量</span>
            <span>{{number}}</span>
          </div>
          <div class="right-content">
            <span class="rc-label">昨　收</span>
            <span>{{timeImfor.yesterday.pro}}</span>
          </div>
          <div class="right-content">
            <span class="rc-label">振　幅</span>
            <span>{{timeImfor.range.pro}}</span>
          </div>
        </div>
      </div>
      <div v-if="nowIcon=='&#xe718;'"
        class="two-top"
        v-show="false">
        <div v-for="(item,index) in timeImfor"
          :key="index">
          <span>{{item.tit}}</span>
          <span>{{item.pro}}</span>
        </div>
      </div>

      <div v-show="nowType==1"
        id="main1"
        class="k-wrapper1"></div>
      <div v-show="nowType==3"
        id="main3"
        class="k-wrapper2"
        @touchstart="longtouch"
        @touchmove="move"
        @touchend="clearLoop"
        @click="showShare"></div>
      <div class="handicap"
        v-if='handIcap'
        ref="handicapEl">
        <div v-for='(item,index) in timeImfor_bottom'
          :key='index'
          :class="['bottom-data',{tcolor:h_color&&index == 'hightPro',
                                  tcolor2:l_color&&index == 'lowPro',
                                  tcolor3:hColor&&index == 'hightPro',
                                  tcolor4:lColor&&index == 'lowPro',
                                  srcolor:sr_color&&index == 'sellPro',
                                  sgcolor:sg_color&&index == 'sellPro',
                                  bgcolor:bg_color&&index == 'buyPro',
                                  brcolor:br_color&&index == 'buyPro',
                                  stopColorg:stop_colorg&&index == 'limitStop',
                                  stopColorr:stop_colorr&&index == 'limitStop',
                                  downColorg:down_colorg&&index == 'limitDown',
                                  downColorr:down_colorr&&index == 'limitDown',}]">
          <span class="bd-label">{{item.tit}}</span>
          <span class="bd-value">{{item.pro}}</span>
          <span class="bd-buy"
            v-if="hasBuy(item)">{{item.buy}}</span>
        </div>
      </div>
    </div>
    <div class="middle">
      <div class="popus"
        v-if='appear_share'>
        <div>
          <span v-for='(item,index) in share'
            :key="index"
            :class='{"clickBackground": index == c_index}'
            @click='cutM(item,index)'>{{item}}</span>
        </div>
      </div>
      <div class="MACDpopus"
        v-if='appear_shareMACD'>
        <div>
          <span v-for='(item,index) in shareMACD'
            :key="index"
            :class='{"clickBackground": index == MACD_index}'
            @click='cutMACD(item,index)'>{{item}}</span>
        </div>
      </div>
      <div class="pardon">
        <span @click='option_k(1)'
          :class="{'slect_k': select_k == 1}">分时</span>
        <span @click='option_k(2)'
          :class="{'slect_k': select_k == 2}">{{minute}}
          <i class="icon iconfont font_icon"
            v-html='seleIcon_m'></i>
        </span>
        <span @click='option_k(3)'
          :class="{'slect_k': select_k == 3}">日</span>
        <span @click='option_k(4)'
          :class="{'slect_k': select_k == 4}">{{week}}
          <i class="icon iconfont font_icon"
            v-html='seleIcon_z'></i>
        </span>
      </div>
      <div style="color:#ccc;width:1.5rem"
        @click='seleMACD'>
        <span v-if="MacdFlage">{{dLink}}
          <i class="icon iconfont font_icon"
            v-html='seleIcon_D'></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import yjheader from "@/components/common/yjheader";
// import kLine from "@/components/common/kLine";
// import * as echarts from "echarts";
import art from "../../../static/js/proto/art/Art.js";
import front from "../../../static/js/proto/CtpFront.js";
let echarts = require("../../assets/js/echarts.js");
echarts = echarts.echarts;
export default {
  name: "market-detail",
  components: {
    yjheader,
    // kLine
  },
  data() {
    return {
      //切换RSI.MACD.KDJ
      targetflage: true,
      targetType: "bar",
      targetColor: function (params) {
        var colorList;
        if (params.data >= 0) {
          colorList = "#B61332";
        } else {
          colorList = "#54FFFF";
        }
        return colorList;
      },
      targetMR: "MACD",
      targetDR: "DIF",
      targetER: "DEA",
      targetSR: "STICK",
      targetData: "(12,26,9)",
      normLine: 0,
      // loading
      showLoading: false,
      // K线上控制滑动变数据,或推送变数据
      dataflage: false,
      //K图
      twoFingers: true,
      categoryData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40],
      values: "",
      volumes: [],
      macds: "",
      difs: "",
      deas: "",
      Loop: "",
      num1: "0.00",
      num2: "0.00",
      num3: "0.00",
      num4: "0.00",
      num5: "0.00",
      num6: "0.00",
      handIcap: true,
      save_num1: 0,
      save_num2: 0,
      minute: "1m",
      week: "周",
      dLink: "MACD",
      seleIcon_m: "&#xe718;",
      seleIcon_z: "&#xe718;",
      seleIcon_D: "&#xe718;",
      appear_share: false,
      appear_shareMACD: false,
      share: [],
      shareMACD: ["MACD", "RSI", "KDJ"],
      MACD_index: 0,
      MacdFlage: false,
      c_index: "-1",
      select_k: 1,
      numMACD: "0.00",
      numDIF: "0.00",
      numDEA: "0.00",
      startValues: 0,
      de_flage: false,
      kType: "",
      typeNum: 0,
      toolArrs: [],
      forty: "",
      fortyX: null,
      fortyEnd: null,
      fortyendValue: null,
      //分时图
      ma_flage: true,
      valueAxis: 0,
      control: true,
      dataLoad: false,
      // allArr: [],
      tooltipArr: [],
      flashTooltipBound: false,
      flashTooltipPinned: false,
      flashTooltipSuppressed: false,
      flashTooltipDataIndex: -1,
      flashTooltipLastToggleTs: 0,
      flashOverlayVisible: false,
      klineTooltipBound: false,
      klineTooltipPinned: false,
      klineTooltipSuppressed: false,
      klineTooltipDataIndex: -1,
      klineTooltipLastToggleTs: 0,
      klineOverlayVisible: false,
      xdata: [],
      optionSer1: [],
      optionSer2: [],
      averagePrice: [],
      flage_s: true,
      xLabel: "",
      compare: "",
      Ymin: 0,
      Ymax: 0,
      Yinterval: 0,
      downLowpro: "",
      downColse: "",
      downHight: "",
      errorMessage: "",
      //数据颜色变化
      //>最高价,最低价
      c_red: false,
      c_green: false,
      c_grey: false,
      h_color: false,
      l_color: false,
      hColor: false,
      lColor: false,
      //>开盘价
      open_color: false,
      open_color2: false,
      //>申买价,申卖价
      br_color: false,
      bg_color: false,
      sr_color: false,
      sg_color: false,
      //>涨停价,跌停价
      stop_colorg: false,
      stop_colorr: false,
      down_colorg: false,
      down_colorr: false,
      timeImfor: {
        yesterday: {
          tit: "昨收盘",
          pro: "0.00",
        },
        range: {
          tit: "振 幅",
          pro: "0.00",
        },
        position: {
          tit: "",
          pro: "",
        },
      },
      timeImfor_bottom: {
        sellPro: {
          tit: "卖一",
          pro: "0.00",
          buy: 0,
        },
        hightPro: {
          tit: "最高",
          pro: "0.00",
        },
        limitStop: {
          tit: "涨停",
          pro: "0.00",
        },
        buyPro: {
          tit: "买一",
          pro: "0.00",
          buy: 0,
        },
        lowPro: {
          tit: "最低",
          pro: "0.00",
        },
        limitDown: {
          tit: "跌停",
          pro: "0.00",
        },
      },
      timeImforFlag: true,
      flage: false,
      open: "0.00",
      turnover: "0",
      close: "0.00",
      number: 0,
      newPrice: "0.00",
      ranges: 0,
      limit: "0.00",
      oldPrice: 0,
      title: this.$route.params.contract,
      nowIcon: "&#xe719;",
      nowType: 1,
      rowData: [],
      selfContract2: "",
      dominantSubscribed: false,
      dominantSuberId: "market-detail-dominant",
      dominantTargetMap: {},
      _flashRenderTimer: null,
      _klineRenderTimer: null,
      _flashLoadToken: 0,
      _flashGapFixCount: 0,
      _flashAxisTarget: "",
      _flashTimeSeqList: [],
      _suppressNextRouteContractWatch: false,
      _routeContractHandledByWatch: "",
      _resizeHandler: null,

      // 懒加载
      lazyLoad: false,
      showLazyLoad: false,
      nonData: false,
      lazyType: "",
      lazyMinute: "",
      startTime: "",
      endPercent: "",
      // oldNum: '',
      // 保留小数点处理
      decimals: 0,
      headerLayoutLevel: 0,
      _lastRightFieldMaxLen: -1,
      _layoutSyncing: false,
      topMiddleMaxWidthPx: null,
      _lastTitle: "",
    };
  },
  computed: {
    targetSelected() {
      return this.$store.state.targetSelected;
    },
    marketDetailNav() {
      return this.$store.state.marketDetailNav;
    },
    contractNameCn() {
      const fromNav = this.marketDetailNav && this.marketDetailNav.targetNameMap ? this.marketDetailNav.targetNameMap[this.title] : "";
      if (fromNav) return fromNav;
      const target = front.targetSet ? front.targetSet[this.title] : null;
      return target && target.targetName ? target.targetName : this.title;
    },
    contractNameEn() {
      return this.title;
    },
    switchTargets() {
      const nav = this.marketDetailNav;
      const navTargets = nav && Array.isArray(nav.targets) ? nav.targets.filter(Boolean) : [];
      if (navTargets.length > 1 && navTargets.indexOf(this.title) !== -1) {
        return navTargets;
      }
      const selected = this.targetSelected ? Object.keys(this.targetSelected) : [];
      if (selected.length > 1 && selected.indexOf(this.title) !== -1) {
        return selected;
      }
      return [];
    },
    canSwitchContract() {
      return this.switchTargets.length > 1;
    },
    isDominantContract() {
      const q = this.$route && this.$route.query ? this.$route.query : null;
      if (q && String(q.dominant) === "1") return true;
      return !!(this.dominantTargetMap && this.dominantTargetMap[this.title]);
    },
    rightFieldMaxLen() {
      const values = [
        this.open,
        this.turnover,
        this.close,
        this.number,
        this.timeImfor && this.timeImfor.yesterday ? this.timeImfor.yesterday.pro : "",
        this.timeImfor && this.timeImfor.range ? this.timeImfor.range.pro : "",
      ].map((v) => (v === null || v === undefined ? "" : String(v)));

      return values.reduce((max, v) => Math.max(max, v.length), 0);
    },
    topMiddleStyle() {
      const lv = Math.max(0, Math.min(4, this.headerLayoutLevel));
      const table = [
        { basis: "40%", minWidth: "2.4rem", paddingLeft: "0", scale: 1 },
        { basis: "34%", minWidth: "2.0rem", paddingLeft: "0", scale: 1 },
        { basis: "28%", minWidth: "1.6rem", paddingLeft: "0", scale: 1 },
        { basis: "24%", minWidth: "1.2rem", paddingLeft: "0", scale: 0.95 },
        { basis: "22%", minWidth: "1.0rem", paddingLeft: "0", scale: 0.9 },
      ];
      const cfg = table[lv];
      const style = {
        flexBasis: cfg.basis,
        minWidth: cfg.minWidth,
        paddingLeft: cfg.paddingLeft,
        paddingRight: "0",
        transform: cfg.scale === 1 ? "" : `scale(${cfg.scale})`,
        transformOrigin: cfg.scale === 1 ? "" : "center center",
      };

      if (typeof this.topMiddleMaxWidthPx === "number" && this.topMiddleMaxWidthPx > 0) {
        style.maxWidth = `${this.topMiddleMaxWidthPx}px`;
      }

      return style;
    },
    data() {
      // console.log(this.rowData)
      return this.rowData.map(function (item) {
        return [+item[1], +item[2], +item[5], +item[6]];
      });
    },
    option1() {
      return {
        backgroundColor: "#1B1C2E",
        title: {
          text: this.errorMessage,
          top: "30%",
          left: "30%",
        },
        xAxis: [
          {
            data: this.xdata,
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                fontSize: 9,
              },
              color: "#ccc",
              formatter: this.xLabel,
            },
            axisPointer: {
              label: {
                show: false,
              },
            },
          },
          //柱
          {
            data: this.xdata,
            gridIndex: 1,
            axisLabel: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
            axisPointer: {
              label: {
                show: false,
              },
            },
          },
          //折线
          // {
          //   data: [],
          //   show: false,
          //   gridIndex: 1,
          //   axisLabel: { show: false },
          //   axisTick: { show: false },
          //   splitLine: { show: false },
          //   axisPointer: {
          //     label: {
          //       show: false
          //     }
          //   }
          // },
          // 均线
          {
            data: this.xdata,
            gridIndex: 1,
            axisLabel: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
            axisPointer: {
              label: {
                show: false,
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            scale: true,
            // splitNumber: 3,
            interval: this.Yinterval,
            min: this.Ymin,
            max: this.Ymax,
            // interval:8,
            // min: 3726,
            // max:3750,
            splitArea: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#555",
                type: "dashed",
                opacity: 0.8,
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisPointer: {
              label: {
                show: false,
              },
            },
            axisLabel: {
              inside: true,
              padding: [0, 0, 15, -5],
              fontSize: 10,
              color: "#999",
              formatter: (val) => {
                var num = front.getTargetPrecision(this.title);
                return val.toFixed(num);
              },
              textStyle: {
                color: (val) => {
                  if (Number(val).toFixed(2) > this.downColse) {
                    return "red";
                  } else if (Number(val).toFixed(2) == this.downColse) {
                    return "#888";
                  } else if (Number(val).toFixed(2) < this.downColse) {
                    return "green";
                  }
                },
              },
            },
          },
          //柱
          {
            type: "value",
            splitNumber: 2,
            scale: true,
            splitArea: {
              show: false,
            },
            gridIndex: 1,
            axisLabel: {
              inside: true,
              padding: [0, 0, 15, -5],
              fontSize: 10,
              color: "#aaa",
              textStyle: {
                color: "#888",
              },
            },
            axisLine: { show: true },
            axisTick: { show: false },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#555",
                type: "dashed",
                opacity: 0.8,
              },
            },
          },
          //折线
          // {
          //   type: "value",
          //   show: false,
          //   scale: true,
          //   splitArea: {
          //     show: false
          //   },
          //   gridIndex: 1,
          //   axisLabel: { show: false },
          //   axisLine: { show: true },
          //   axisTick: { show: false },
          //   splitLine: { show: false }
          // },
          // 均线
          {
            type: "value",
            show: false,
            scale: true,
            splitArea: {
              show: false,
            },
            gridIndex: 0,
            axisLabel: { show: false },
            axisLine: { show: true },
            axisTick: { show: false },
            splitLine: { show: false },
          },
        ],
        //两个图的位置
        grid: [
          {
            top: "12%",
            height: "48%",
            width: "100%",
            x: 0,
            x2: 0,
            borderWidth: 1,
          },
          //柱
          {
            top: "77%",
            height: "17%",
            width: "100%",
            x: 0,
            x2: 0,
          },
          //折线
          {
            top: "12%",
            height: "48%",
            width: "100%",
            x: 0,
            x2: 0,
            borderWidth: 1,
          },
        ],
        tooltip: {
          show: this.flashOverlayVisible,
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: { show: false },
            lineStyle: {
              color: "rgba(226, 232, 240, 0.55)",
              width: 1,
              type: "solid",
            },
            crossStyle: {
              color: "rgba(226, 232, 240, 0.75)",
              width: 1,
              type: "solid",
            },
          },
          alwaysShowContent: this.flashOverlayVisible,
          confine: true,
          backgroundColor: "rgba(17, 24, 39, 0.88)",
          borderWidth: 1,
          borderColor: "rgba(148, 163, 184, 0.35)",
          padding: [8, 10],
          textStyle: { color: "#E5E7EB", fontSize: 12 },
          extraCssText: "border-radius:6px;box-shadow:0 6px 18px rgba(0,0,0,0.35);pointer-events:none;",
          formatter: (val) => {
            const p0 = val && val.length ? val[0] : null;
            if (!p0) return "";

            const seq = Array.isArray(p0.data) ? p0.data[0] : p0.axisValue;
            const dataIndex = p0.dataIndex;
            const decimals = typeof this.decimals === "number" ? this.decimals : front.getTargetPrecision(this.title);

            const toNum = (v) => {
              const n = Number(v);
              return Number.isFinite(n) ? n : null;
            };
            const trimZeros = (s) => String(s).replace(/\.?0+$/, "");
            const formatPrice = (v) => {
              const n = toNum(v);
              if (n === null) return "";
              return trimZeros(n.toFixed(decimals));
            };
            const formatSigned = (v) => {
              const n = toNum(v);
              if (n === null) return "";
              const raw = trimZeros(n.toFixed(decimals));
              return n > 0 ? "+" + raw : raw;
            };
            const formatPercent = (v) => {
              const n = toNum(v);
              if (n === null) return "";
              const raw = trimZeros(n.toFixed(2)) + "%";
              return n > 0 ? "+" + raw : raw;
            };
            const formatBigNumber = (v) => {
              const n = toNum(v);
              if (n === null) return v == null ? "" : String(v);
              const abs = Math.abs(n);
              if (abs >= 100000000) return trimZeros((n / 100000000).toFixed(2)) + "亿";
              if (abs >= 10000) return trimZeros((n / 10000).toFixed(2)) + "万";
              return String(n);
            };
            const escapeHtml = (s) =>
              String(s)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;");
            const formatTime = (t) => {
              const s = t == null ? "" : String(t);
              const m = s.match(/(\d{2}:\d{2})(?::\d{2})?/);
              return m ? m[1] : s;
            };

            let info = null;
            if (this.tooltipArr && typeof dataIndex === "number" && dataIndex >= 0 && dataIndex < this.tooltipArr.length) {
              const candidate = this.tooltipArr[dataIndex];
              if (candidate && candidate.num == seq) info = candidate;
            }
            if (!info && this.tooltipArr && this.tooltipArr.length) {
              for (let i = 0; i < this.tooltipArr.length; i++) {
                if (this.tooltipArr[i] && this.tooltipArr[i].num == seq) {
                  info = this.tooltipArr[i];
                  break;
                }
              }
            }

            const time = formatTime(info && info.time ? info.time : p0.axisValueLabel || "");
            const price = info && info.priceClose != null ? info.priceClose : Array.isArray(p0.data) ? p0.data[1] : null;
            const avg = info && info.priceAverage != null ? info.priceAverage : null;
            const volume = info ? info.volume : null;
            const position = info ? info.position : null;
            const baseClose = toNum(this.downColse);
            const priceNum = toNum(price);
            const change = baseClose !== null && baseClose !== 0 && priceNum !== null ? priceNum - baseClose : null;
            const changePct = baseClose !== null && baseClose !== 0 && priceNum !== null ? (change * 100) / baseClose : null;

            const changeColor = change === null ? "#E5E7EB" : change > 0 ? "#FF4D4F" : change < 0 ? "#22C55E" : "#E5E7EB";

            const row = (label, value, color) => {
              if (value == null || value === "") return "";
              const v = escapeHtml(value);
              const c = color || "#E5E7EB";
              return `<div style="margin-top:6px"><div style="color:#94A3B8;line-height:14px">${escapeHtml(label)}</div><div style="color:${c};font-weight:600;line-height:16px">${v}</div></div>`;
            };

            let html = `<div style="display:inline-block"><div style="margin-bottom:6px;font-weight:700;color:#F9FAFB;line-height:16px;white-space:nowrap">${escapeHtml(time)}</div>`;
            html += row("价格", formatPrice(price), changeColor);
            html += row("均价", formatPrice(avg), "#FDE047");
            html += row("涨跌", change === null ? "" : formatSigned(change), changeColor);
            html += row("涨跌幅", changePct === null ? "" : formatPercent(changePct), changeColor);
            html += row("成交量", volume == null ? "" : formatBigNumber(volume), "#E5E7EB");
            html += row("持仓量", position == null ? "" : formatBigNumber(position), "#E5E7EB");
            html += "</div>";
            return html;
          },
          position: function (pos, params, el, elRect, size) {
            const margin = 10;
            const top = 16;
            const tooltipWidth = size.contentSize[0];
            const viewWidth = size.viewSize[0];
            let left = margin;
            const leftBoxRight = left + tooltipWidth;
            if (pos[0] <= leftBoxRight + 2) {
              left = viewWidth - tooltipWidth - margin;
            }
            if (left < margin) left = margin;
            if (left + tooltipWidth > viewWidth - margin) left = viewWidth - tooltipWidth - margin;
            return { top, left };
          },
        },
        axisPointer: {
          show: this.flashOverlayVisible,
          link: { xAxisIndex: "all" },
          label: {
            backgroundColor: "#777",
          },
          lineStyle: {
            color: "rgba(226, 232, 240, 0.55)",
            width: 1,
            type: "solid",
          },
        },
        series: [
          {
            animation: false,
            data: this.optionSer1,
            type: "line",
            symbol: "none",
            progressive: 0,
            progressiveThreshold: 0,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#fff",
                  width: 1,
                },
              },
            },
          },
          //柱
          {
            animation: false,
            name: "Volume",
            type: "bar",
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: this.optionSer2,
            barWidth: 0.3,
            progressive: 0,
            progressiveThreshold: 0,
          },
          //折线
          // {
          //   name: "Line",
          //   type: "line",
          //   xAxisIndex: 1,
          //   yAxisIndex: 1,
          //   data: [],
          //   lineStyle: {
          //     width: 1
          //   },
          //   symbol: "none"
          // },
          // 均线
          {
            animation: false,
            name: "Line",
            type: "line",
            xAxisIndex: 0,
            yAxisIndex: 0,
            // data: [[20,4000],[30,4050],[100,4000]],
            data: this.averagePrice,
            progressive: 0,
            progressiveThreshold: 0,
            lineStyle: {
              color: "#DCDC0A",
              width: 1,
            },
            symbol: "none",
          },
        ],
      };
    },
    option3() {
      return {
        backgroundColor: "#1B1C2E",
        animation: false,
        animationDuration: 0,
        animationDelay: 0,
        animationDurationUpdate: 0,
        animationDelayUpdate: 0,
        title: {
          text: this.errorMessage,
          top: "30%",
          left: "30%",
        },
        legend: [
          {
            animation: false,
            top: 0,
            left: "left",
            itemWidth: 0,
            formatter: (name) => {
              if (name == "MA5") {
                return name + ":" + Number(this.num1).toFixed(1);
              } else if (name == "MA10") {
                return name + ":" + Number(this.num2).toFixed(1);
              } else if (name == "MA20") {
                return name + ":" + Number(this.num3).toFixed(1);
              } else if (name == "MA60") {
                return name + ":" + Number(this.num4).toFixed(1);
              }
            },
            data: [
              {
                name: "MA5",
                icon: "none",
                textStyle: {
                  color: "#fff",
                },
              },
              {
                name: "MA10",
                icon: "none",
                textStyle: {
                  color: "#2B65EA",
                },
              },
              {
                name: "MA20",
                icon: "none",
                textStyle: {
                  color: "#42A668",
                },
              },
              {
                name: "MA60",
                icon: "none",
                textStyle: {
                  color: "#A13BCB",
                },
              },
            ],
          },
          {
            // 显示Volume
            formatter: (name) => {
              if (name == "Volume") {
                // return name + ":" + this.num5;
                // 柱状折线
                // } else if (name == "Line") {
                //   return name + ":" + this.num6;
              }
            },
            animation: false,
            left: "left",
            itemWidth: 0,
            top: "52%",
            data: [
              {
                name: "Volume",
                icon: "none",
                textStyle: {
                  color: "#ddd",
                },
              },
              {
                name: "Line",
                icon: "none",
                textStyle: {
                  color: "green",
                },
              },
            ],
          },
          {
            formatter: (name) => {
              if (name == this.targetMR) {
                return name + ":" + this.targetData;
              } else if (name == this.targetDR) {
                return name + ":" + Number(this.numDIF).toFixed(2);
              } else if (name == this.targetER) {
                return name + ":" + Number(this.numDEA).toFixed(2);
              } else if (name == this.targetSR) {
                // return name + ":" + this.numSTICK;
                return name + ":" + Number(this.numMACD).toFixed(2);
              }
            },
            left: "left",
            itemWidth: 0,
            top: "74%",
            left: "3%",
            data: [
              {
                name: this.targetMR,
                icon: "none",
                textStyle: {
                  color: "#9a9a9a",
                },
              },
              {
                name: this.targetDR,
                icon: "none",
                textStyle: {
                  color: "#fff",
                },
              },
              {
                name: this.targetER,
                icon: "none",
                textStyle: {
                  color: "yellow",
                },
              },
              {
                name: this.targetSR,
                icon: "none",
                textStyle: {
                  color: "#FF00FF",
                },
              },
            ],
          },
        ],
        axisPointer: {
          type: "line",
          show: this.klineOverlayVisible || this.de_flage,
          link: { xAxisIndex: "all" },
          label: {
            show: true,
            backgroundColor: "#777",
          },
          lineStyle: {
            color: "transparent",
          },
        },
        tooltip: {
          show: this.klineOverlayVisible || this.de_flage,
          trigger: "axis",
          formatter: (param, ticket, callback) => {
            if (!(this.klineOverlayVisible || this.de_flage)) return "";

            const list = Array.isArray(param) ? param : [];
            const pick = (name) => list.find((p) => p && p.seriesName === name);

            const ma5 = pick("MA5");
            const ma10 = pick("MA10");
            const ma20 = pick("MA20");
            const ma60 = pick("MA60");
            const vol = pick("Volume");
            const mr = pick(this.targetMR);
            const dr = pick(this.targetDR);
            const er = pick(this.targetER);

            this.num1 = ma5 && ma5.data !== "-" ? ma5.data : "0.00";
            this.num2 = ma10 && ma10.data !== "-" ? ma10.data : "0.00";
            this.num3 = ma20 && ma20.data !== "-" ? ma20.data : "0.00";
            this.num4 = ma60 && ma60.data !== "-" ? ma60.data : "0.00";
            this.num5 = vol && Array.isArray(vol.data) ? vol.data[1] : this.num5;
            this.numMACD = mr && mr.data !== "-" ? mr.data : this.numMACD;
            this.numDIF = dr && dr.data !== "-" ? dr.data : this.numDIF;
            this.numDEA = er && er.data !== "-" ? er.data : this.numDEA;

            const candle = list.find((p) => p && p.seriesType === "candlestick") || list[0];
            const dataIndex = candle && typeof candle.dataIndex === "number" ? candle.dataIndex : -1;

            const decimals = typeof this.decimals === "number" ? this.decimals : front.getTargetPrecision(this.title);
            const toNum = (v) => {
              const n = Number(v);
              return Number.isFinite(n) ? n : null;
            };
            const trimZeros = (s) => String(s).replace(/\.?0+$/, "");
            const formatPrice = (v) => {
              const n = toNum(v);
              if (n === null) return "";
              return trimZeros(n.toFixed(decimals));
            };
            const formatPercent = (v) => {
              const n = toNum(v);
              if (n === null) return "";
              return trimZeros(n.toFixed(2)) + "%";
            };
            const formatBigNumber = (v) => {
              const n = toNum(v);
              if (n === null) return v == null ? "" : String(v);
              const abs = Math.abs(n);
              if (abs >= 100000000) return trimZeros((n / 100000000).toFixed(2)) + "亿";
              if (abs >= 10000) return trimZeros((n / 10000).toFixed(2)) + "万";
              return String(n);
            };
            const escapeHtml = (s) =>
              String(s)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;");
            const splitDateTime = (raw) => {
              const s = raw == null ? "" : String(raw);
              let m = s.match(/(\d{4})[-/ ]?(\d{2})[-/ ]?(\d{2})(?:\s+|T)?(\d{2}:\d{2})(?::\d{2})?/);
              if (m) return { date: `${m[1]}/${m[2]}/${m[3]}`, time: m[4] };
              m = s.match(/(\d{4})[-/ ]?(\d{2})[-/ ]?(\d{2})/);
              if (m) return { date: `${m[1]}/${m[2]}/${m[3]}`, time: "" };
              m = s.match(/(\d{2}:\d{2})(?::\d{2})?/);
              if (m) return { date: "", time: m[1] };
              return { date: s, time: "" };
            };

            const tool = Array.isArray(this.toolArrs) && dataIndex >= 0 && dataIndex < this.toolArrs.length ? this.toolArrs[dataIndex] : null;
            const row = Array.isArray(this.rowData) && dataIndex >= 0 && dataIndex < this.rowData.length ? this.rowData[dataIndex] : null;

            const timeRaw = (tool && tool.time) || (row && row[0]) || (candle && (candle.axisValueLabel || candle.axisValue)) || "";
            const dt = splitDateTime(timeRaw);

            const open = tool && tool.priceOpen != null ? tool.priceOpen : row ? row[1] : null;
            const close = tool && tool.priceClose != null ? tool.priceClose : row ? row[2] : null;
            const low = tool && tool.priceLow != null ? tool.priceLow : row ? row[5] : null;
            const high = tool && tool.priceHigh != null ? tool.priceHigh : row ? row[6] : null;
            const volume = tool && tool.volume != null ? tool.volume : row ? row[7] : null;
            const position = tool && tool.position != null ? tool.position : null;

            const openNum = toNum(open);
            const closeNum = toNum(close);
            const base = toNum(this.close) || closeNum;
            const amp = base && base !== 0 && toNum(high) != null && toNum(low) != null ? ((toNum(high) - toNum(low)) * 100) / base : null;
            const closeColor = closeNum == null || openNum == null ? "#E5E7EB" : closeNum > openNum ? "#FF4D4F" : closeNum < openNum ? "#22C55E" : "#E5E7EB";
            const openColor = "#60A5FA";
            const highColor = "#F59E0B";
            const lowColor = "#34D399";
            const volColor = "#A78BFA";
            const ampColor = "#FDE047";
            const posColor = "#F472B6";

            const rowHtml = (label, value, color) => {
              if (value == null || value === "") return "";
              const v = escapeHtml(value);
              const c = color || "#E5E7EB";
              return `<div style="margin-top:6px"><div style="color:#94A3B8;line-height:14px">${escapeHtml(label)}</div><div style="color:${c};font-weight:600;line-height:16px">${v}</div></div>`;
            };

            let header = "";
            if (dt.date) header += `<div style="font-weight:700;color:#F9FAFB;line-height:16px;white-space:nowrap">${escapeHtml(dt.date)}</div>`;
            if (dt.time) header += `<div style="font-weight:700;color:#CBD5E1;line-height:16px;white-space:nowrap">${escapeHtml(dt.time)}</div>`;
            if (!header) header = `<div style="font-weight:700;color:#F9FAFB;line-height:16px;white-space:nowrap">${escapeHtml(timeRaw)}</div>`;

            let html = `<div style="display:inline-block;border-left:3px solid ${closeColor};padding-left:10px">${header}`;
            html += rowHtml("开盘", formatPrice(open), openColor);
            html += rowHtml("收盘", formatPrice(close), closeColor);
            html += rowHtml("最高", formatPrice(high), highColor);
            html += rowHtml("最低", formatPrice(low), lowColor);
            html += rowHtml("成交量", volume == null ? "" : formatBigNumber(volume), volColor);
            html += rowHtml("振幅", amp == null ? "" : formatPercent(amp), ampColor);
            html += rowHtml("持仓量", position == null ? "" : formatBigNumber(position), posColor);
            html += "</div>";
            return html;
          },
          alwaysShowContent: this.klineOverlayVisible || this.de_flage,
          confine: true,
          backgroundColor: "rgba(17, 24, 39, 0.88)",
          borderWidth: 1,
          borderColor: "rgba(148, 163, 184, 0.35)",
          padding: [8, 10],
          textStyle: { color: "#E5E7EB", fontSize: 12 },
          extraCssText: "border-radius:6px;box-shadow:0 6px 18px rgba(0,0,0,0.35);pointer-events:none;",
          axisPointer: {
            // snap: true,
            type: "cross",
            label: {
              show: false,
            },
            lineStyle: {
              color: "rgba(226, 232, 240, 0.55)",
              width: 1,
              type: "solid",
            },
            crossStyle: {
              color: "rgba(226, 232, 240, 0.75)",
              width: 1,
              type: "solid",
            },
          },
          position: function (pos, params, el, elRect, size) {
            const margin = 10;
            const top = 16;
            const tooltipWidth = size.contentSize[0];
            const viewWidth = size.viewSize[0];
            let left = margin;
            const leftBoxRight = left + tooltipWidth;
            if (pos[0] <= leftBoxRight + 2) {
              left = viewWidth - tooltipWidth - margin;
            }
            if (left < margin) left = margin;
            if (left + tooltipWidth > viewWidth - margin) left = viewWidth - tooltipWidth - margin;
            return { top, left };
          },
        },
        toolbox: {
          show: false,
        },
        visualMap: {
          realtime: false,
          show: false,
          seriesIndex: 5,
          dimension: 2,
          pieces: [
            {
              value: 1,
              color: "#54FFFF",
            },
            {
              value: -1,
              color: "#B61332",
            },
          ],
        },
        grid: [
          {
            top: "6%",
            height: "46%",
            width: "98%",
            left: "1%",
            right: "1%",
            x: 0,
            x2: 0,
            borderWidth: 1,
          },
          {
            top: "54%",
            height: "20%",
            width: "98%",
            left: "1%",
            right: "1%",
            x: 0,
            x2: 0,
          },
          {
            top: "76%",
            height: "20%",
            width: "98%",
            left: "1%",
            right: "1%",
            x: 0,
            x2: 0,
          },
        ],
        xAxis: [
          {
            boundaryGap: false,
            type: "category",
            data: this.categoryData,
            scale: true,
            splitLine: { show: false },
            axisPointer: {
              z: 100,
              snap: false,
              label: {
                show: false,
              },
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#ccc",
                opacity: 0.4,
              },
            },
            axisLabel: {
              interval: 999999,
              showMinLabel: true,
              showMaxLabel: true,
              formatter: this.forty,
              color: "#aaa",
              margin: 2,
              fontsize: 10,
            },
            axisTick: {
              show: false,
            },
            triggerEvent: true,
          },
          {
            type: "category",
            gridIndex: 1,
            data: this.categoryData,
            scale: true,
            axisLine: { onZero: false },
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
            axisPointer: {
              snap: false,
              label: {
                show: false, //X轴指示器
              },
            },
            min: "dataMin",
            max: "dataMax",
          },
          {
            type: "category",
            gridIndex: 1,
            data: this.categoryData,
            axisLine: { onZero: false },
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
            axisPointer: {
              snap: false,
            },
            min: "dataMin",
            max: "dataMax",
          },
          {
            type: "category",
            gridIndex: 2,
            data: this.categoryData,
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
            axisPointer: {
              label: {
                formatter: this.fortyX,
              },
            },
          },
        ],
        yAxis: [
          {
            scale: true,
            splitNumber: 2,
            min: "dataMin",
            // min: function(val) {
            //   return Math.floor(Number(val.min));
            // },
            max: "dataMax",
            // max: function(val) {
            // return Math.ceil(Number(val.max));
            // },
            splitArea: {
              show: false,
            },
            axisPointer: {
              snap: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#333",
                type: "dashed",
                opacity: 0.8,
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              inside: true,
              padding: [0, 0, 15, -5],
              fontSize: 10,
              color: "#666",
              formatter: (value, index) => {
                var val = (value * 1000).toFixed(0) / 1000;
                return val;
              },
            },
          },
          {
            scale: true,
            gridIndex: 1,
            splitNumber: 2,
            legendHoverLink: false,
            axisLabel: {
              inside: true,
              padding: [0, 0, 15, -5],
              fontSize: 10,
              color: "#666",
            },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#333",
                type: "dashed",
                opacity: 0.8,
              },
            },
            axisPointer: {
              snap: false,
            },
          },
          {
            type: "value",
            scale: true,
            legendHoverLink: false,
            axisLabel: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
            axisPointer: {
              snap: false,
            },
          },
          {
            gridIndex: 2,
            scale: true,
            legendHoverLink: false,
            splitNumber: 2,
            min: "dataMin",
            max: "dataMax",
            splitArea: {
              show: false,
            },
            axisPointer: {
              snap: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#333",
                type: "dashed",
                opacity: 0.8,
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: function (val, index) {
                return val.toFixed(0);
              },
              inside: true,
              padding: [0, 0, 15, -5],
              fontSize: 10,
              color: "#666",
            },
          },
        ],
        dataZoom: [
          {
            id: "klineInsideZoom",
            type: "inside",
            filterMode: "filter",
            xAxisIndex: [0, 1, 3],
            endValue: this.fortyendValue, // 初始化显示的根数
            startValue: this.startValues,
            end: this.fortyEnd,
            throttle: 0,
            animation: false,
            // animationDurationUpdate: 0,
            maxSpan: 100, //缩放到最小时能看到的百分比
            minValueSpan: 16, // 缩放到最大时的根数, (参考广发证券)
            preventDefaultMouseMove: true,
            moveOnMouseMove: !(this.klineOverlayVisible || this.de_flage),
            left: "20%",
          },
          {
            show: false,
          },
        ],
        series: [
          {
            animation: false,
            name: "Dow-Jones index",
            type: "candlestick",
            data: this.data,
            // barMaxWidth: 20,
            legendHoverLink: false,
            hoverAnimation: false,
            showSymbol: false,
            itemStyle: {
              normal: {
                color: "#B61332",
                color0: "#54FFFF",
                color1: "#fff",
                borderColor: null,
                borderColor0: null,
              },
            },
            large: false,
            progressive: 0,
            progressiveThreshold: 0,
          },
          {
            name: "MA5",
            type: "line",
            data: this.calculateMA(5, this.data),
            smooth: true,
            symbol: "none",
            hoverAnimation: false,
            legendHoverLink: false,
            animation: false,
            lineStyle: {
              normal: { opacity: 0.5, color: "#fff", width: 2 },
            },
          },
          {
            name: "MA10",
            type: "line",
            symbol: "none",
            data: this.calculateMA(10, this.data),
            smooth: true,
            hoverAnimation: false,
            legendHoverLink: false,
            animation: false,
            lineStyle: {
              normal: { opacity: 0.5, color: "#2B65EA", width: 2 },
            },
          },
          {
            name: "MA20",
            type: "line",
            symbol: "none",
            data: this.calculateMA(20, this.data),
            smooth: true,
            hoverAnimation: false,
            legendHoverLink: false,
            animation: false,
            lineStyle: {
              normal: { opacity: 0.5, color: "#42A668", width: 2 },
            },
          },
          {
            name: "MA60",
            type: "line",
            symbol: "none",
            data: this.calculateMA(60, this.data),
            smooth: true,
            hoverAnimation: false,
            legendHoverLink: false,
            animation: false,
            lineStyle: {
              normal: { opacity: 0.5, color: "#A13BCB", width: 2 },
            },
          },
          {
            name: "Volume",
            type: "bar",
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: this.volumes,
            // barMaxWidth: 20,
            animation: false,
            large: true,
          },
          //   // 柱状折线
          // {
          //   name: "Line",
          //   type: "line",
          //   symbol: "none",
          //   hoverAnimation: false,
          // legendHoverLink: false,
          //   animation: false,
          //   xAxisIndex: 1,
          //   yAxisIndex: 1,
          //   // data: this.volumes
          // },
          {
            name: this.targetMR,
            type: this.targetType,
            // symbol:'none',
            xAxisIndex: 3,
            yAxisIndex: 3,
            // barMaxWidth: 2,
            data: this.macds,
            itemStyle: {
              normal: {
                color: this.targetColor,
              },
            },
          },
          {
            name: this.targetDR,
            type: "line",
            symbol: "none",
            xAxisIndex: 3,
            yAxisIndex: 3,
            data: this.difs,
            smooth: false,
            itemStyle: {
              normal: {
                color: "#fff",
              },
            },
            lineStyle: {
              width: 1,
            },
          },
          {
            name: this.targetER,
            type: "line",
            symbol: "none",
            xAxisIndex: 3,
            yAxisIndex: 3,
            data: this.deas,
            smooth: false,
            itemStyle: {
              normal: {
                color: "yellow",
              },
            },
            lineStyle: {
              width: 1,
            },
          },
          {
            name: this.targetSR,
            type: "line",
            symbol: "none",
            xAxisIndex: 3,
            yAxisIndex: 3,
            data: [],
            smooth: true,
          },
        ],
      };
    },
  },

  watch: {
    "$route.params.contract"(next) {
      if (this._suppressNextRouteContractWatch) {
        this._suppressNextRouteContractWatch = false;
        return;
      }
      if (next && next !== this.title) {
        this._routeContractHandledByWatch = next;
        const oldTitle = this.title;

        clearTimeout(this.Loop);
        if (oldTitle) {
          this.cancel(oldTitle, this.kType, this.typeNum);
          this.callOf(oldTitle);
        }

        this.rowData = [];
        this.volumes = [];
        this.optionSer1 = [];
        this.averagePrice = [];
        this.optionSer2 = [];
        if (this.option1 && this.option1.series && this.option1.series[2]) {
          this.option1.series[2].data = [];
        }
        this.toolArrs = [];
        this.showLoading = false;
        this.tooltipArr = [];
        this.open = "0";
        this.turnover = "0";
        this.number = "0";
        this.newPrice = "0";
        this.close = "0";
        this.ranges = "0";
        this.limit = "0.00";
        this.Yinterval = 0;
        this.Ymin = 0;
        this.Ymax = 0;
        this.downLowpro = "";
        this.downColse = "";
        this.downHight = "";
        this.compare = null;
        this.flage_s = true;
        this.timeImfor_bottom = {
          sellPro: { tit: "卖一", pro: "0.00", buy: 0 },
          hightPro: { tit: "最高", pro: "0.00" },
          limitStop: { tit: "涨停", pro: "0.00" },
          buyPro: { tit: "买一", pro: "0.00", buy: 0 },
          lowPro: { tit: "最低", pro: "0.00" },
          limitDown: { tit: "跌停", pro: "0.00" },
        };

        this.title = next;
        this.decimals = front.getTargetPrecision(this.title);
        if (this.targetSelected && this.targetSelected[this.title] != undefined) {
          this.selfContract2 = "&#xe617;";
        } else {
          this.selfContract2 = "&#xe63c;";
        }

        if (this.select_k === 1) {
          this.nowType = 1;
          this.handIcap = true;
          this.control = true;
          this.flashOverlayVisible = false;
          this.flashTooltipSuppressed = true;
          this.flashTooltipPinned = false;
          this.flashTooltipDataIndex = -1;
          this.callOf(this.title);
          this.kType = front.ktype_minute;
          this.typeNum = 1;
          this.datumAxis(this.title, () => {
            this.loadingData(this.title, front.ktype_minute, 1);
          });
          return;
        }

        this.nowType = 3;
        this.handIcap = false;
        this.MacdFlage = true;
        if (this.select_k === 2) {
          this.minuteK(this.save_num1);
        } else if (this.select_k === 3) {
          this.oneLine(this.title, front.ktype_day, 1);
          this.kType = front.ktype_day;
          this.typeNum = 1;
        } else if (this.select_k === 4) {
          this.weekK(this.save_num2);
        } else {
          this.minuteK(this.save_num1);
        }
        this.loadingData(this.title, front.ktype_minute, 1, { silent: true, quoteOnly: true });
      }
    },
  },

  updated() {
    // 逻辑：如果右侧数字最大长度变化，或者合约标题变化，则重新计算布局防止重叠
    if (this._lastRightFieldMaxLen !== this.rightFieldMaxLen || this._lastTitle !== this.title) {
      this._lastRightFieldMaxLen = this.rightFieldMaxLen;
      this._lastTitle = this.title;
      this.syncHeaderLayout();
    }
  },

  beforeDestroy() {
    clearTimeout(this.Loop);
    if (this._flashRenderTimer) {
      clearTimeout(this._flashRenderTimer);
      this._flashRenderTimer = null;
    }
    if (this._klineRenderTimer) {
      clearTimeout(this._klineRenderTimer);
      this._klineRenderTimer = null;
    }
    if (this._resizeHandler) {
      window.removeEventListener("resize", this._resizeHandler);
      this._resizeHandler = null;
    }
    const main3Dom = document.getElementById("main3");
    const main3Chart = main3Dom ? echarts.getInstanceByDom(main3Dom) : null;
    if (main3Chart) main3Chart.dispose();

    const main1Dom = document.getElementById("main1");
    const main1Chart = main1Dom ? echarts.getInstanceByDom(main1Dom) : null;
    if (main1Chart) main1Chart.dispose();
  },

  methods: {
    _scheduleFlashRender() {
      if (this._flashRenderTimer) return;
      this._flashRenderTimer = setTimeout(() => {
        this._flashRenderTimer = null;
        const chart = this.getMain1Chart();
        if (!chart) return;
        chart.setOption(this.option1, false);
        this.bindFlashTooltipBehavior();
        this.restoreFlashTooltip();
      }, 120);
    },
    _scheduleKlineRender() {
      if (this._klineRenderTimer) return;
      this._klineRenderTimer = setTimeout(() => {
        this._klineRenderTimer = null;
        this.splitData3(this.rowData);
        const chart = this.getMain3Chart();
        if (!chart) return;
        chart.setOption(
          {
            title: {},
            series: [
              { data: this.data },
              { data: this.calculateMA(5, this.data) },
              { data: this.calculateMA(10, this.data) },
              { data: this.calculateMA(20, this.data) },
              { data: this.calculateMA(60, this.data) },
              { data: this.volumes },
              { data: this.macds },
              { data: this.difs },
              { data: this.deas },
            ],
            xAxis: [
              {
                data: this.categoryData,
                axisLabel: {
                  showMinLabel: true,
                  showMaxLabel: true,
                  formatter: this.forty,
                },
              },
              { data: this.categoryData, min: "dataMin", max: "dataMax" },
              { data: this.categoryData, min: "dataMin", max: "dataMax" },
            ],
            yAxis: [{ min: "dataMin", max: "dataMax" }],
          },
          false
        );
        this.bindKlineTooltipBehavior();
        this.restoreKlineTooltip();
      }, 120);
    },
    _hasFlashGap() {
      const timeSeqList = Array.isArray(this._flashTimeSeqList) ? this._flashTimeSeqList : [];
      if (!timeSeqList.length) return true;

      const firstSeq = Number(timeSeqList[0] && timeSeqList[0].seq);
      const expectedFirst = Number.isFinite(firstSeq) ? firstSeq : 0;

      const received = Object.create(null);
      let uniqueCount = 0;
      let maxSeq = -1;
      const s = Array.isArray(this.optionSer1) ? this.optionSer1 : [];
      for (let i = 0; i < s.length; i++) {
        const p = s[i];
        const seq = Array.isArray(p) ? Number(p[0]) : NaN;
        if (!Number.isFinite(seq)) continue;
        const k = String(seq);
        if (!received[k]) {
          received[k] = true;
          uniqueCount += 1;
        }
        if (seq > maxSeq) maxSeq = seq;
      }
      if (maxSeq < expectedFirst + 10 || uniqueCount < 8) return false;

      const expectedSeqs = [];
      for (let i = 0; i < timeSeqList.length; i++) {
        const seq = Number(timeSeqList[i] && timeSeqList[i].seq);
        if (!Number.isFinite(seq)) continue;
        if (seq < expectedFirst) continue;
        if (seq > maxSeq) break;
        expectedSeqs.push(seq);
      }
      if (expectedSeqs.length < 10) return false;

      let firstPresent = null;
      for (let i = 0; i < expectedSeqs.length; i++) {
        if (received[String(expectedSeqs[i])]) {
          firstPresent = expectedSeqs[i];
          break;
        }
      }
      if (firstPresent == null) return true;
      if (firstPresent > expectedFirst + 2) return true;

      const windowEnd = Math.min(maxSeq, expectedFirst + 60);
      let missing = 0;
      let run = 0;
      let bestRun = 0;
      for (let i = 0; i < expectedSeqs.length; i++) {
        const seq = expectedSeqs[i];
        if (seq > windowEnd) break;
        if (!received[String(seq)]) {
          missing += 1;
          run += 1;
          if (run > bestRun) bestRun = run;
        } else {
          run = 0;
        }
      }
      if (bestRun >= 10 && missing >= 10) return true;

      return false;
    },
    _fixFlashGap(title, token, forceReload) {
      if (token !== this._flashLoadToken) return;
      if (this.select_k !== 1) return;
      if (this.title !== title) return;
      if (this._flashGapFixCount >= 1) return;
      if (!forceReload && !this._hasFlashGap()) return;

      this._flashGapFixCount += 1;
      this.control = true;
      this.flage_s = true;
      this.datumAxis(title, () => {
        if (token !== this._flashLoadToken) return;
        if (this.select_k !== 1) return;
        if (this.title !== title) return;
        if (!forceReload && !this._hasFlashGap()) return;
        this.callOf(title);
        this.kType = front.ktype_minute;
        this.typeNum = 1;
        this.loadingData(title, front.ktype_minute, 1, { silent: true, prefilled: false, _gapFix: this._flashGapFixCount });
      });
    },
    switchContract(step) {
      if (!this.canSwitchContract) return;
      const targets = this.switchTargets;
      const idx = targets.indexOf(this.title);
      if (idx === -1) return;
      const next = targets[(idx + step + targets.length) % targets.length];
      if (!next || next === this.title) return;
      this.$router.replace({ path: "/marketDetail/" + next, query: this.$route.query });
    },
    getMain1Chart() {
      const dom = document.getElementById("main1");
      if (!dom) return null;
      return echarts.getInstanceByDom(dom) || echarts.init(dom);
    },
    getMain3Chart() {
      const dom = document.getElementById("main3");
      if (!dom) return null;
      return echarts.getInstanceByDom(dom) || echarts.init(dom);
    },
    bindFlashTooltipBehavior() {
      if (this.flashTooltipBound) return;
      const chart = this.getMain1Chart();
      if (!chart) return;

      this.flashTooltipBound = true;

      chart.on("updateAxisPointer", (event) => {
        if (!this.flashOverlayVisible) return;
        if (this.flashTooltipSuppressed) return;
        const axesInfo = event && event.axesInfo ? event.axesInfo : [];
        if (!axesInfo.length) return;
        const first = axesInfo[0];
        const sdi = first && first.seriesDataIndices ? first.seriesDataIndices : [];
        if (!sdi.length) return;
        const di = sdi[0] && typeof sdi[0].dataIndex === "number" ? sdi[0].dataIndex : -1;
        if (di < 0) return;
        this.flashTooltipPinned = true;
        this.flashTooltipDataIndex = di;
      });

      const zr = chart.getZr();
      const onBlankTap = (e) => {
        const now = Date.now();
        if (now - (this.flashTooltipLastToggleTs || 0) < 250) return;
        this.flashTooltipLastToggleTs = now;

        const x = e && typeof e.offsetX === "number" ? e.offsetX : null;
        const y = e && typeof e.offsetY === "number" ? e.offsetY : null;
        if (x == null || y == null) return;

        let dataIndex = null;
        const target = e ? e.target : null;
        const ecData = target && target.__ecData ? target.__ecData : null;
        if (Array.isArray(ecData) && ecData.length) {
          for (let i = 0; i < ecData.length; i++) {
            const di = ecData[i] && typeof ecData[i].dataIndex === "number" ? ecData[i].dataIndex : null;
            if (di != null) {
              dataIndex = di;
              break;
            }
          }
        }

        const nextVisible = !this.flashOverlayVisible;
        this.flashOverlayVisible = nextVisible;
        this.flashTooltipSuppressed = !nextVisible;

        if (!nextVisible) {
          this.flashTooltipPinned = false;
          this.flashTooltipDataIndex = -1;
          chart.setOption({ tooltip: { show: false, alwaysShowContent: false }, axisPointer: { show: false } }, false);
          chart.dispatchAction({ type: "hideTip" });
          chart.dispatchAction({ type: "updateAxisPointer", currTrigger: "leave" });
          return;
        }

        chart.setOption({ tooltip: { show: true, alwaysShowContent: true }, axisPointer: { show: true } }, false);

        const s1 = Array.isArray(this.optionSer1) ? this.optionSer1 : [];
        if (!s1.length) {
          this.flashOverlayVisible = false;
          this.flashTooltipSuppressed = true;
          chart.setOption({ tooltip: { show: false, alwaysShowContent: false }, axisPointer: { show: false } }, false);
          return;
        }

        if (dataIndex == null) {
          const raw = chart.convertFromPixel({ xAxisIndex: 0 }, x);
          const seq = typeof raw === "number" ? raw : Number(raw);
          const targetSeq = Number.isFinite(seq) ? seq : Number(s1[s1.length - 1] && s1[s1.length - 1][0]);

          let bestIndex = 0;
          let bestDist = Number.POSITIVE_INFINITY;
          for (let i = 0; i < s1.length; i++) {
            const p = s1[i];
            const sx = Array.isArray(p) ? Number(p[0]) : null;
            if (!Number.isFinite(sx)) continue;
            const dist = Math.abs(sx - targetSeq);
            if (dist < bestDist) {
              bestDist = dist;
              bestIndex = i;
            }
            if (bestDist === 0) break;
          }
          dataIndex = bestIndex;
        }

        this.flashTooltipPinned = true;
        this.flashTooltipDataIndex = dataIndex;
        this.restoreFlashTooltip();
      };

      zr.on("click", onBlankTap);
      zr.on("tap", onBlankTap);
    },
    restoreFlashTooltip() {
      if (!this.flashOverlayVisible) return;
      if (this.flashTooltipSuppressed) return;
      if (!this.flashTooltipPinned) return;
      const chart = this.getMain1Chart();
      if (!chart) return;
      const di = this.flashTooltipDataIndex;
      if (typeof di !== "number" || di < 0) return;
      if (!this.optionSer1 || di >= this.optionSer1.length) return;
      chart.dispatchAction({ type: "showTip", seriesIndex: 0, dataIndex: di });
    },
    bindKlineTooltipBehavior() {
      if (this.klineTooltipBound) return;
      const chart = this.getMain3Chart();
      if (!chart) return;

      this.klineTooltipBound = true;

      chart.on("updateAxisPointer", (event) => {
        if (!(this.klineOverlayVisible || this.de_flage)) return;
        if (this.klineTooltipSuppressed) return;
        const axesInfo = event && event.axesInfo ? event.axesInfo : [];
        if (!axesInfo.length) return;
        const first = axesInfo[0];
        const sdi = first && first.seriesDataIndices ? first.seriesDataIndices : [];
        if (!sdi.length) return;
        const di = sdi[0] && typeof sdi[0].dataIndex === "number" ? sdi[0].dataIndex : -1;
        if (di < 0) return;
        this.klineTooltipPinned = true;
        this.klineTooltipDataIndex = di;
      });

      const zr = chart.getZr();
      const onBlankTap = (e) => {
        const now = Date.now();
        if (now - (this.klineTooltipLastToggleTs || 0) < 250) return;
        this.klineTooltipLastToggleTs = now;

        let dataIndex = null;
        const target = e ? e.target : null;
        const ecData = target && target.__ecData ? target.__ecData : null;
        if (Array.isArray(ecData) && ecData.length) {
          for (let i = 0; i < ecData.length; i++) {
            const di = ecData[i] && typeof ecData[i].dataIndex === "number" ? ecData[i].dataIndex : null;
            if (di != null) {
              dataIndex = di;
              break;
            }
          }
        }

        const nextVisible = !this.klineOverlayVisible;
        this.klineOverlayVisible = nextVisible;
        this.klineTooltipSuppressed = !nextVisible;

        if (!nextVisible) {
          this.klineTooltipPinned = false;
          this.klineTooltipDataIndex = -1;
          chart.setOption({ tooltip: { show: false, alwaysShowContent: false }, axisPointer: { show: false } }, false);
          this.updateKlinePanLock();
          chart.dispatchAction({ type: "hideTip" });
          chart.dispatchAction({ type: "updateAxisPointer", currTrigger: "leave" });
          return;
        }

        chart.setOption({ tooltip: { show: true, alwaysShowContent: true }, axisPointer: { show: true } }, false);
        this.updateKlinePanLock();

        const n = Array.isArray(this.rowData) ? this.rowData.length : 0;
        if (!n) {
          this.klineOverlayVisible = false;
          this.klineTooltipSuppressed = true;
          chart.setOption({ tooltip: { show: false, alwaysShowContent: false }, axisPointer: { show: false } }, false);
          this.updateKlinePanLock();
          return;
        }

        if (dataIndex == null) dataIndex = n - 1;
        dataIndex = Math.max(0, Math.min(n - 1, dataIndex));
        this.klineTooltipPinned = true;
        this.klineTooltipDataIndex = dataIndex;
        this.restoreKlineTooltip();
      };

      zr.on("click", onBlankTap);
      zr.on("tap", onBlankTap);
    },
    restoreKlineTooltip() {
      if (!this.klineOverlayVisible && !this.de_flage) return;
      if (this.klineTooltipSuppressed) return;
      if (!this.klineTooltipPinned) return;
      const chart = this.getMain3Chart();
      if (!chart) return;
      const di = this.klineTooltipDataIndex;
      const n = Array.isArray(this.rowData) ? this.rowData.length : 0;
      if (typeof di !== "number" || di < 0 || di >= n) return;
      chart.dispatchAction({ type: "showTip", seriesIndex: 0, dataIndex: di });
    },
    updateKlinePanLock() {
      const chart = this.getMain3Chart();
      if (!chart) return;
      const cur = chart.getOption ? chart.getOption() : null;
      if (!cur || !cur.xAxis || !cur.xAxis.length || !cur.series || !cur.series.length) return;
      const locked = this.klineOverlayVisible || this.de_flage;
      chart.setOption(
        {
          dataZoom: [
            {
              id: "klineInsideZoom",
              moveOnMouseMove: !locked,
            },
          ],
        },
        false
      );
    },
    syncChartSize() {
      const wrapper = this.$refs.two_top;
      const topBar = this.$refs.topBar;
      if (!wrapper || !topBar) return;

      const wrapperHeight = wrapper.clientHeight || 0;
      const topHeight = topBar.clientHeight || 0;

      let handicapHeight = 0;
      const handicapEl = this.$refs.handicapEl;
      if (handicapEl && this.handIcap) {
        handicapHeight = handicapEl.clientHeight || 0;
      }

      const availableHeight = Math.max(0, wrapperHeight - topHeight - handicapHeight);
      const w = window.innerWidth || 0;

      const main1 = document.getElementById("main1");
      if (main1) {
        main1.style.width = w + "px";
        main1.style.height = availableHeight + "px";
      }
      const main3 = document.getElementById("main3");
      if (main3) {
        main3.style.width = w + "px";
        main3.style.height = availableHeight + "px";
      }

      const c1 = this.getMain1Chart();
      if (c1) c1.resize();
      this.bindFlashTooltipBehavior();
      this.restoreFlashTooltip();
      const c3 = this.getMain3Chart();
      if (c3) c3.resize();
      this.bindKlineTooltipBehavior();
      this.restoreKlineTooltip();
      this.updateKlinePanLock();
    },
    subscribeDominantTargets() {
      if (this.dominantSubscribed) return;
      if (front.ready && !front.ready()) return;
      this.dominantSubscribed = true;
      front.dominantTargetSub({
        suberId: this.dominantSuberId,
        publish: (pub) => {
          if (!pub || !pub.targetId) return;
          if (pub.stamp === art.meta.stamp_remove) {
            this.$delete(this.dominantTargetMap, pub.targetId);
          } else {
            this.$set(this.dominantTargetMap, pub.targetId, true);
          }
        },
      });
    },
    refreshSelfIcon() {
      if (this.targetSelected && this.targetSelected[this.title] != undefined) {
        this.selfContract2 = "&#xe617;";
      } else {
        this.selfContract2 = "&#xe63c;";
      }
    },
    resetForContractChange(oldTitle) {
      clearTimeout(this.Loop);
      if (oldTitle) {
        this.cancel(oldTitle, this.kType, this.typeNum);
        this.callOf(oldTitle);
      }
      this.rowData = [];
      this.volumes = [];
      this.optionSer1 = [];
      this.averagePrice = [];
      this.optionSer2 = [];
      if (this.option1 && this.option1.series && this.option1.series[2]) {
        this.option1.series[2].data = [];
      }
      this.toolArrs = [];
      this.showLoading = false;
      this.tooltipArr = [];
      this.open = "0";
      this.turnover = "0";
      this.number = "0";
      this.newPrice = "0";
      this.close = "0";
      this.ranges = "0";
      this.limit = "0.00";
      this.flage_s = true;
      this.timeImfor_bottom = {
        sellPro: { tit: "卖一", pro: "0.00", buy: 0 },
        hightPro: { tit: "最高", pro: "0.00" },
        limitStop: { tit: "涨停", pro: "0.00" },
        buyPro: { tit: "买一", pro: "0.00", buy: 0 },
        lowPro: { tit: "最低", pro: "0.00" },
        limitDown: { tit: "跌停", pro: "0.00" },
      };
    },
    onContractRouteChange(nextTitle) {
      const oldTitle = this.title;
      this.resetForContractChange(oldTitle);
      this.title = nextTitle;
      this.decimals = front.getTargetPrecision(this.title);
      this.refreshSelfIcon();

      if (this.select_k === 1) {
        this.nowType = 1;
        this.handIcap = true;
        this.control = true;
        this.callOf(this.title);
        this.kType = front.ktype_minute;
        this.typeNum = 1;
        this.datumAxis(this.title, () => {
          this.loadingData(this.title, front.ktype_minute, 1);
        });
        return;
      }

      this.nowType = 3;
      this.handIcap = false;
      this.MacdFlage = true;
      if (this.select_k === 2) {
        this.minuteK(this.save_num1);
      } else if (this.select_k === 3) {
        this.oneLine(this.title, front.ktype_day, 1);
        this.kType = front.ktype_day;
        this.typeNum = 1;
      } else if (this.select_k === 4) {
        this.weekK(this.save_num2);
      } else {
        this.minuteK(this.save_num1);
      }
    },
    hasBuy(item) {
      return item && Object.prototype.hasOwnProperty.call(item, "buy");
    },
    formatPrice(value) {
      if (value === null || value === undefined || value === "") return "--";
      const n = Number(value);
      if (!Number.isFinite(n)) return String(value);
      return n.toFixed(this.decimals);
    },
    goBack() {
      this.appear_shareMACD = false;
      this.seleIcon_D = "&#xe718;";
      this.MacdFlage = false;
      window.history.back();
    },
    syncHeaderLayout() {
      if (this._layoutSyncing) return;
      this._layoutSyncing = true;

      this.$nextTick(() => {
        const rightEl = this.$refs.topRight;
        const leftEl = this.$refs.back;
        if (!rightEl || !leftEl) {
          this._layoutSyncing = false;
          return;
        }

        const headerEl = rightEl.closest(".top");
        if (!headerEl) {
          this._layoutSyncing = false;
          return;
        }

        const headerWidth = headerEl.clientWidth;
        const rightNeed = rightEl.scrollWidth;
        const edge = 12; // 保留一点边缘，避免紧贴
        const leftMin = 90; // 最小保留：避免左侧完全挤没
        const availableLeft = Math.max(leftMin, headerWidth - rightNeed - edge);

        this.topMiddleMaxWidthPx = availableLeft;

        if (availableLeft >= 220) this.headerLayoutLevel = 0;
        else if (availableLeft >= 180) this.headerLayoutLevel = 1;
        else if (availableLeft >= 140) this.headerLayoutLevel = 2;
        else if (availableLeft >= 110) this.headerLayoutLevel = 3;
        else this.headerLayoutLevel = 4;

        this._layoutSyncing = false;
      });
    },
    order() {
      this.$router.push({ path: "/tradeDetail/0" });
      localStorage.contractorNo = this.title;
    }, // 自选合约
    select(item) {
      // 添加自选合约
      if (this.selfContract2 == "&#xe63c;") {
        front.selectedTargetAdd(
          item,
          (resolve) => {
            this.$toast("添加自选成功");
            this.selfContract2 = "&#xe617;";
            this.$store.commit("selectInsert", item);
          },
          (reject) => {
            if (reject.id == front.e_network) {
              this.$toast("添加自选失败，网络异常");
            } else if (reject.id == front.e_selected_repeated) {
              this.$toast("添加自选重复");
            } else {
              this.$toast("添加自选失败");
            }
          }
        );
        return;
      }
      // 删除自选合约
      if (this.selfContract2 == "&#xe617;") {
        front.selectedTargetRemove(
          item,
          (resolve) => {
            this.selfContract2 = "&#xe63c;";
            this.$toast("删除自选成功");
            this.$store.commit("selectRemove", item);
          },
          (reject) => {
            if (reject.id == front.e_network) {
              this.$toast("删除自选失败，网络异常");
            } else if (reject.id == front.e_selected_removed) {
              this.$toast("删除自选重复");
            } else {
              this.$toast("删除自选失败");
            }
          }
        );
      }
    },
    //点击选择不同分时图
    option_k(index) {
      this.showLazyLoad = false;
      //切换分时,K线图
      this.appear_share = index == 1 || index == 3 ? false : true;
      if (index == 1) {
        this.appear_shareMACD = false;
        this.seleIcon_D = "&#xe718;";
        this.showLoading = true;
        this.select_k = 1;
        this.cancel(this.title, this.kType, this.typeNum);
        this.callOf(this.title);
        this.nowType = 1;
        this.handIcap = true;
        this.control = true;
        this.flage_s = true;
        this.kType = front.ktype_minute;
        this.typeNum = 1;
        this.datumAxis(this.title, () => {
          this.loadingData(this.title, front.ktype_minute, 1, { silent: false, prefilled: false });
        });
        this.$nextTick(() => {
          this.syncChartSize();
        });
        this.MacdFlage = false;
      } else {
        const orderTick = front.subTick(this.title, "trade-detail");
        this.decimals = art.digit(orderTick.priceTick);
        this.MacdFlage = true;
        var kreq = {
          targetId: this.title,
          ktype: front.ktype_minute,
          kunit: 1,
        };
        front.unsubKbar2(kreq, "market-flash");
        // front.unsubTick(title, "market-datail");
        // this.callOf(this.title);
        if (this.nowType != 3) {
          this.nowType = 3;
          this.handIcap = false;
          this.splitData3(this.rowData);
          this.$nextTick(() => {
            this.syncChartSize();
            const c3 = this.getMain3Chart();
            if (c3) {
              c3.clear();
              c3.setOption(this.option3, true);
            }
          });
        }
      }

      if (index == 2) {
        if (this.select_k == 2) {
          this.appear_shareMACD = false;
          this.seleIcon_D = "&#xe718;";
          this.seleIcon_m = this.seleIcon_m == "&#xe718;" ? "&#xe719;" : "&#xe718;";
          this.appear_share = this.seleIcon_m == "&#xe718;" ? false : true;
          this.share = ["1m", "3m", "5m", "10m", "30m", "1h", "2h", "4h"];
          this.c_index = this.save_num1;
        } else {
          this.select_k = 2;
          this.showLoading = true;
          this.appear_share = false;
          this.cancel(this.title, this.kType, this.typeNum);
          this.minuteK(this.save_num1);
        }
      } else {
        this.seleIcon_m = "&#xe718;";
        this.seleIcon_D = "&#xe718;";
      }
      if (index == 3) {
        this.select_k = 3;
        if (process.env.NODE_ENV === "development") console.log("日K线图");
        this.cancel(this.title, this.kType, this.typeNum);
        this.oneLine(this.title, front.ktype_day, 1);
        this.kType = front.ktype_day;
        this.typeNum = 1;
      }
      if (index == 4) {
        if (this.select_k == 4) {
          this.appear_shareMACD = false;
          this.seleIcon_D = "&#xe718;";
          this.seleIcon_z = this.seleIcon_z == "&#xe718;" ? "&#xe719;" : "&#xe718;";
          this.appear_share = this.seleIcon_z == "&#xe718;" ? false : true;
          this.share = ["周", "月", "季", "年"];
          this.c_index = this.save_num2;
        } else {
          this.appear_share = false;
          this.cancel(this.title, this.kType, this.typeNum);
          this.weekK(this.save_num2);
        }
        this.select_k = 4;
      } else {
        this.seleIcon_z = "&#xe718;";
        this.seleIcon_D = "&#xe718;";
      }
    },
    // 切换不同的分时K线图
    minuteK(index) {
      switch (index) {
        case 0:
          if (process.env.NODE_ENV === "development") console.log("这是一分钟K线");
          this.oneLine(this.title, front.ktype_minute, 1);
          this.kType = front.ktype_minute;
          this.typeNum = 1;
          break;
        case 1:
          if (process.env.NODE_ENV === "development") console.log("这是三分钟K线");
          this.oneLine(this.title, front.ktype_minute, 3);
          this.kType = front.ktype_minute;
          this.typeNum = 3;
          break;
        case 2:
          if (process.env.NODE_ENV === "development") console.log("这是五分钟K线");
          this.oneLine(this.title, front.ktype_minute, 5);
          this.kType = front.ktype_minute;
          this.typeNum = 5;
          break;
        case 3:
          if (process.env.NODE_ENV === "development") console.log("这是10分钟K线");
          this.oneLine(this.title, front.ktype_minute, 10);
          this.kType = front.ktype_minute;
          this.typeNum = 10;
          break;
        case 4:
          if (process.env.NODE_ENV === "development") console.log("这是30分钟K线");
          this.oneLine(this.title, front.ktype_minute, 30);
          this.kType = front.ktype_minute;
          this.typeNum = 30;
          break;
        case 5:
          if (process.env.NODE_ENV === "development") console.log("这是1小时K线");
          this.oneLine(this.title, front.ktype_hour, 1);
          this.kType = front.ktype_hour;
          this.typeNum = 1;
          break;
        case 6:
          if (process.env.NODE_ENV === "development") console.log("这是2小时K线");
          this.oneLine(this.title, front.ktype_hour, 2);
          this.kType = front.ktype_hour;
          this.typeNum = 2;
          break;
        case 7:
          if (process.env.NODE_ENV === "development") console.log("这是4小时K线");
          this.oneLine(this.title, front.ktype_hour, 4);
          this.kType = front.ktype_hour;
          this.typeNum = 4;
          break;
      }
    },
    // 切换不同周K线图
    weekK(index) {
      switch (index) {
        case 0:
          if (process.env.NODE_ENV === "development") console.log("这是周K线");
          this.oneLine(this.title, front.ktype_week, 1);
          this.kType = front.ktype_week;
          this.typeNum = 1;
          break;
        case 1:
          if (process.env.NODE_ENV === "development") console.log("这是月K线");
          this.oneLine(this.title, front.ktype_month, 1);
          this.kType = front.ktype_month;
          this.typeNum = 1;
          break;
        case 2:
          if (process.env.NODE_ENV === "development") console.log("这是季K线");
          this.oneLine(this.title, front.ktype_season, 1);
          this.kType = front.ktype_season;
          this.typeNum = 1;
          break;
        case 3:
          if (process.env.NODE_ENV === "development") console.log("这是年K线");
          this.oneLine(this.title, front.ktype_year, 1);
          this.kType = front.ktype_year;
          this.typeNum = 1;
          break;
      }
    },
    //选择不同的分时图,周图
    cutM(item, index) {
      // 取消订阅上一个
      this.cancel(this.title, this.kType, this.typeNum);
      //点击变换背景颜色,切换字体
      this.c_index = index;
      if (this.select_k == 2) {
        this.minute = item;
        this.save_num1 = index;
      } else if (this.select_k == 4) {
        this.week = item;
        this.save_num2 = index;
      }
      if (this.seleIcon_m == "&#xe719;") {
        this.minuteK(index);
      } else if (this.seleIcon_z == "&#xe719;") {
        this.weekK(index);
      }
    },
    cutMACD(item, index) {
      this.MACD_index = index;
      this.dLink = item;
      let u_dif = unescape("_ec_%00DIF%000_series.line");
      let u_dea = unescape("_ec_%00DEA%000_series.line");
      let data = echarts.init(document.getElementById("main3"))._chartsMap;
      let exDifs = data[u_dif].__model.option.data[data[u_dif].__model.parentModel.option.dataZoom[1].endValue];
      let exDeas = exDeas;
      switch (index) {
        case 0:
          console.log("这是MACD线");
          this.targetType = "bar";
          this.targetflage = true;
          this.normLine = 0;
          (this.targetMR = "MACD"),
            (this.targetDR = "DIF"),
            (this.targetER = "DEA"),
            (this.targetSR = "STICK"),
            (this.sargetData = "(12,26,9)"),
            (this.targetColor = function (params) {
              var colorList;
              if (params.data >= 0) {
                colorList = "#B61332";
              } else {
                colorList = "#54FFFF";
              }
              return colorList;
            }),
            this.splitData3(this.rowData);
          var u_macd = unescape("_ec_%00MACD%000_series.bar");
          echarts.init(document.getElementById("main3")).setOption({
            series: [
              {},
              {},
              {},
              {},
              {},
              {},
              {
                name: this.targetMR,
                type: this.targetType,
                xAxisIndex: 3,
                yAxisIndex: 3,
                data: this.macds,
                itemStyle: {
                  normal: {
                    color: this.targetColor,
                  },
                },
              },
              {
                data: this.difs,
                name: this.targetDR,
              },
              {
                data: this.deas,
                name: this.targetER,
              },
              {
                name: this.targetSR,
              },
            ],
          });
          if (!isNaN(data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue])) {
            this.numMACD = data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue];
          }
          if (!isNaN(exDifs)) {
            this.numDIF = exDifs;
          }
          if (!isNaN(exDeas)) {
            this.numDEA = exDeas;
          }
          echarts.init(document.getElementById("main3")).setOption({
            legend: [
              {},
              {},
              {
                formatter: (name) => {
                  if (name == this.targetMR) {
                    return name + ":" + this.sargetData;
                  } else if (name == this.targetDR) {
                    return name + ":" + Number(this.numDIF).toFixed(2);
                  } else if (name == this.targetER) {
                    return name + ":" + Number(this.numDEA).toFixed(2);
                  } else if (name == this.targetSR) {
                    return name + ":" + Number(this.numMACD).toFixed(2);
                  }
                },
                data: [
                  {
                    name: this.targetMR,
                    icon: "none",
                    textStyle: {
                      color: "#9a9a9a",
                    },
                  },
                  {
                    name: this.targetDR,
                    icon: "none",
                    textStyle: {
                      color: "#fff",
                    },
                  },
                  {
                    name: this.targetER,
                    icon: "none",
                    textStyle: {
                      color: "yellow",
                    },
                  },
                  {
                    name: this.targetSR,
                    icon: "none",
                    textStyle: {
                      color: "#FF00FF",
                    },
                  },
                ],
              },
            ],
          });
          break;
        case 1:
          this.targetType = "line";
          this.targetflage = false;
          this.normLine = 1;
          this.targetColor = "#ff00ff";
          this.targetMR = "RSI";
          this.targetDR = "RSI1";
          this.targetER = "RSI2";
          this.targetSR = "RSI3";
          this.sargetData = "(6,12,24)";
          console.log("这是RSI线");
          this.splitData3(this.rowData);
          var u_macd = unescape("_ec_%00MACD%000_series.line");
          echarts.init(document.getElementById("main3")).setOption({
            series: [
              {},
              {},
              {},
              {},
              {},
              {},
              {
                name: this.targetMR,
                type: this.targetType,
                symbol: "none",
                xAxisIndex: 3,
                yAxisIndex: 3,
                data: this.macds,
                smooth: false,
                itemStyle: {
                  normal: {
                    color: this.targetColor,
                  },
                },
                lineStyle: {
                  width: 1,
                },
              },
              {
                data: this.difs,
                name: this.targetDR,
              },
              {
                data: this.deas,
                name: this.targetER,
              },
              {
                name: this.targetSR,
              },
            ],
          });
          if (!isNaN(data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue])) {
            this.numMACD = data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue];
          }
          if (!isNaN(exDifs)) {
            this.numDIF = exDifs;
          }
          if (!isNaN(exDeas)) {
            this.numDEA = exDeas;
          }
          echarts.init(document.getElementById("main3")).setOption({
            legend: [
              {},
              {},
              {
                formatter: (name) => {
                  if (name == this.targetMR) {
                    return name + ":" + this.sargetData;
                  } else if (name == this.targetDR) {
                    return name + ":" + Number(this.numDIF).toFixed(2);
                  } else if (name == this.targetER) {
                    return name + ":" + Number(this.numDEA).toFixed(2);
                  } else if (name == this.targetSR) {
                    return name + ":" + Number(this.numMACD).toFixed(2);
                  }
                },
                data: [
                  {
                    name: this.targetMR,
                    icon: "none",
                    textStyle: {
                      color: "#9a9a9a",
                    },
                  },
                  {
                    name: this.targetDR,
                    icon: "none",
                    textStyle: {
                      color: "#fff",
                    },
                  },
                  {
                    name: this.targetER,
                    icon: "none",
                    textStyle: {
                      color: "yellow",
                    },
                  },
                  {
                    name: this.targetSR,
                    icon: "none",
                    textStyle: {
                      color: "#FF00FF",
                    },
                  },
                ],
              },
            ],
          });
          break;
        case 2:
          this.targetType = "line";
          this.targetflage = false;
          this.normLine = 2;
          this.targetColor = "#ff00ff";
          this.targetMR = "KDJ";
          this.targetDR = "K";
          this.targetER = "D";
          this.targetSR = "J";
          this.sargetData = "(9,3,3)";
          console.log("这是KDJ线");
          this.splitData3(this.rowData);
          var u_macd = unescape("_ec_%00MACD%000_series.line");
          echarts.init(document.getElementById("main3")).setOption({
            series: [
              {},
              {},
              {},
              {},
              {},
              {},
              {
                name: this.targetMR,
                type: this.targetType,
                symbol: "none",
                xAxisIndex: 3,
                yAxisIndex: 3,
                data: this.macds,
                smooth: false,
                itemStyle: {
                  normal: {
                    color: this.targetColor,
                  },
                },
                lineStyle: {
                  width: 1,
                },
              },
              {
                data: this.difs,
                name: this.targetDR,
              },
              {
                data: this.deas,
                name: this.targetER,
              },
              {
                name: this.targetSR,
              },
            ],
          });
          if (!isNaN(data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue])) {
            this.numMACD = data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue];
          }
          if (!isNaN(exDifs)) {
            this.numDIF = exDifs;
          }
          if (!isNaN(exDeas)) {
            this.numDEA = exDeas;
          }
          echarts.init(document.getElementById("main3")).setOption({
            legend: [
              {},
              {},
              {
                formatter: (name) => {
                  if (name == this.targetMR) {
                    return name + ":" + this.sargetData;
                  } else if (name == this.targetDR) {
                    return name + ":" + Number(this.numDIF).toFixed(2);
                  } else if (name == this.targetER) {
                    return name + ":" + Number(this.numDEA).toFixed(2);
                  } else if (name == this.targetSR) {
                    return name + ":" + Number(this.numMACD).toFixed(2);
                  }
                },
                data: [
                  {
                    name: this.targetMR,
                    icon: "none",
                    textStyle: {
                      color: "#9a9a9a",
                    },
                  },
                  {
                    name: this.targetDR,
                    icon: "none",
                    textStyle: {
                      color: "#fff",
                    },
                  },
                  {
                    name: this.targetER,
                    icon: "none",
                    textStyle: {
                      color: "yellow",
                    },
                  },
                  {
                    name: this.targetSR,
                    icon: "none",
                    textStyle: {
                      color: "#FF00FF",
                    },
                  },
                ],
              },
            ],
          });
          break;
      }
    },
    //选择MACD.RSI
    seleMACD() {
      if (this.nowType == 3) {
        // console.log(this.select_k);
        // this.select_k = "-1";
        this.seleIcon_D = this.seleIcon_D == "&#xe718;" ? "&#xe719;" : "&#xe718;";
        this.appear_shareMACD = this.seleIcon_D == "&#xe718;" ? false : true;
        this.seleIcon_m = "&#xe718;";
        this.seleIcon_z = "&#xe718;";
        this.appear_share = false;
        console.log("切换MACD");
      }
    },
    // 点击屏幕事件
    showShare() {
      this.appear_share = false;
      this.appear_shareMACD = false;
      this.seleIcon_m = "&#xe718;";
      this.seleIcon_z = "&#xe718;";
      this.seleIcon_D = "&#xe718;";
    },
    //屏幕长按事件
    longtouch(e) {
      e.stopPropagation();
      this.twoFingers = true;
      clearTimeout(this.Loop);
      this.Loop = setTimeout(() => {
        if (this.twoFingers) {
          this.de_flage = true;
          this.dataflage = true;
          if (!this.klineOverlayVisible) {
            this.klineOverlayVisible = true;
            this.klineTooltipSuppressed = false;
            const n = Array.isArray(this.rowData) ? this.rowData.length : 0;
            if (n) {
              this.klineTooltipPinned = true;
              this.klineTooltipDataIndex = n - 1;
              const chart = this.getMain3Chart();
              if (chart) chart.setOption({ tooltip: { show: true, alwaysShowContent: true }, axisPointer: { show: true } }, false);
              this.restoreKlineTooltip();
            }
          }
          this.updateKlinePanLock();
        }
      }, 1000);
    },
    clearLoop() {
      clearTimeout(this.Loop);
      this.de_flage = false;
      this.dataflage = false;
      this.updateKlinePanLock();
      // 继续右滑加载更多数据
      if (this.lazyLoad) {
        if (this.showLazyLoad) return;
        this.showLazyLoad = true;
        this.startTime = this.rowData[0][0];
        // console.log('加载数据中.................................................................................')
        var kReq = {
          targetId: this.title,
          ktype: this.lazyType,
          kunit: this.lazyMinute,
          kquery: front.kquery_size,
          ksize: 100,
          endTime: this.startTime,
        };
        front.getKbar2(
          kReq,
          (kbar, last) => {
            if (kbar.length == 0) {
              this.showLazyLoad = false;
              this.nonData = true;
              setTimeout(() => {
                this.nonData = false;
              }, 1500);
            } else {
              const arr = kbar.reverse();
              for (const i of kbar) {
                this.rowData.unshift([i.time, i.priceOpen, i.priceClose, "-", "-", i.priceLow, i.priceHigh, i.volume]);
              }
              for (const i of arr) {
                this.toolArrs.unshift(i);
              }
              this.splitData3(this.rowData);
              // 重算视图开始位置的比例: 加载根数/现在共有根数
              const start = (kbar.length / this.rowData.length) * 100;
              // 重算视图结束位置的比例: 原结束比例*原总根数+加载根数/现共有根数
              const end = (((this.endPercent / 100) * (this.rowData.length - kbar.length) + kbar.length) / this.rowData.length) * 100;
              echarts.init(document.getElementById("main3")).setOption({
                title: {},
                series: [
                  {
                    data: this.data,
                  },
                  {
                    data: this.calculateMA(5, this.data),
                  },
                  {
                    data: this.calculateMA(10, this.data),
                  },
                  {
                    data: this.calculateMA(20, this.data),
                  },
                  {
                    data: this.calculateMA(60, this.data),
                  },
                  {
                    data: this.volumes,
                  },
                  //指标图
                  {
                    data: this.macds,
                  },
                  {
                    data: this.difs,
                  },
                  {
                    data: this.deas,
                  },
                ],
                xAxis: [
                  {
                    data: this.categoryData,
                    axisLine: {
                      onZero: true,
                    },
                  },
                  {
                    data: this.categoryData,
                  },
                  {
                    data: this.categoryData,
                  },
                  {
                    data: this.categoryData,
                  },
                ],
                dataZoom: [
                  {
                    type: "inside",
                    start: start,
                    end: end,
                  },
                  {},
                ],
              });
              this.showLazyLoad = false;
            }
            this.showLazyLoad = false;
          },
          function (error) {
            suber.reject(error);
            console.log(error);
            this.showLazyLoad = false;
          }
        );
      }
    },
    move(e) {
      e.stopPropagation();
      this.twoFingers = false;
      if (this.de_flage) {
        e.preventDefault();
      }
      clearTimeout(this.Loop);
    },

    changeIcon() {
      if (this.nowIcon == "&#xe719;") {
        this.nowIcon = "&#xe718;";
      } else if (this.nowIcon == "&#xe718;") {
        this.nowIcon = "&#xe719;";
      }
    },
    //取消订阅1分K线图
    cancel(title, ktype, mins) {
      var kreq = { targetId: title, ktype: ktype, kunit: mins };
      front.unsubKbar2(kreq, "market-kbar");
    },
    // K线图
    oneLine(title, ktype, minute) {
      this.lazyType = ktype;
      this.lazyMinute = minute;
      this.rowData = [];
      this.volumes = [];
      this.macds = [];
      this.difs = [];
      this.deas = [];
      this.toolArrs = [];
      this.showLoading = true;
      this.dataLoad = false;
      const chart = this.getMain3Chart();
      if (chart) {
        chart.clear();
        chart.setOption(this.option3, true);
      }
      let that = this;
      var kreq = {
        targetId: title,
        ktype: ktype,
        kunit: minute,
        kquery: front.kquery_size,
        ksize: 50,
      };
      front.subKbar2(kreq, {
        suberId: "market-kbar",
        reject: function (error) {
          if (error) {
            that.showLoading = false;
            that.errorMessage = error.message;
            const c3 = that.getMain3Chart();
            if (c3) {
              c3.clear();
              c3.setOption(that.option3, true);
            }
          }
        },
        publish: function (kbar, type) {
          // console.log(type);
          // console.log(kbar);
          // let hour1 = kbar.updateDate.substr(0, 4);
          // let hour2 = kbar.updateDate.substr(4, 2);
          // let hour3 = kbar.updateDate.substr(6, 2);
          // let hour4 = kbar.time;

          // let time = hour1 + "-" + hour2 + "-" + hour3 + " " + hour4;
          if (kbar.stamp == 1) {
            that.rowData.splice(that.rowData.length - 1, 1, [kbar.time, kbar.priceOpen, kbar.priceClose, "-", "-", kbar.priceLow, kbar.priceHigh, kbar.volume]);
          } else {
            that.rowData.push([kbar.time, kbar.priceOpen, kbar.priceClose, "-", "-", kbar.priceLow, kbar.priceHigh, kbar.volume]);
            that.toolArrs.push(kbar);
          }
          // that.oldNum = that.rowData.length;
          if (that.ma_flage) {
            that.splitData3(that.rowData);
            if (that.option3.series[1].data[that.option3.series[1].data.length - 1] != "-") {
              that.num1 = that.option3.series[1].data[that.option3.series[1].data.length - 1];
            }
            if (that.option3.series[2].data[that.option3.series[2].data.length - 1] != "-") {
              that.num2 = that.option3.series[2].data[that.option3.series[2].data.length - 1];
            }
            if (that.option3.series[3].data[that.option3.series[3].data.length - 1] != "-") {
              that.num3 = that.option3.series[3].data[that.option3.series[3].data.length - 1];
            }
            if (that.option3.series[4].data[that.option3.series[4].data.length - 1] != "-") {
              that.num4 = that.option3.series[4].data[that.option3.series[4].data.length - 1];
            }
            if (that.option3.series[5].data[that.option3.series[5].data.length - 1][1] != "-") {
              that.num5 = that.option3.series[5].data[that.option3.series[5].data.length - 1][1];
            }
            if (that.option3.series[6].data[that.option3.series[6].data.length - 1] != "-") {
              that.numMACD = that.option3.series[6].data[that.option3.series[6].data.length - 1];
            }
            if (that.option3.series[7].data[that.option3.series[7].data.length - 1] != "-") {
              that.numDIF = that.option3.series[7].data[that.option3.series[7].data.length - 1];
            }
            if (that.option3.series[8].data[that.option3.series[8].data.length - 1] != "-") {
              that.numDEA = that.option3.series[8].data[that.option3.series[8].data.length - 1];
            }
            // 柱状折线
            // if (that.option3.series[6].data[ that.option3.series[6].data.length - 1][1] != '-') {
            //   that.num6 = that.option3.series[6].data[ that.option3.series[6].data.length - 1][1];
            // }
          }
          if (that.dataLoad) {
            that._scheduleKlineRender();
          }
          if (art.hasValue(type, art.content_last)) {
            that.startTime = that.rowData[0][0];
            (that.errorMessage = ""), (that.dataLoad = true);
            that.showLoading = false;
            that.startValues = that.data.length - 40;
            that.splitData3(that.rowData);
            const c3 = that.getMain3Chart();
            if (c3) {
              c3.clear();
              c3.setOption(that.option3, true);
              that.bindKlineTooltipBehavior();
              that.restoreKlineTooltip();
            }
          }
        },
      });
    },
    splitData3(rawData) {
      let rawDatas = [];
      for (var i = 0; i < rawData.length; i++) {
        rawDatas.push([]);
        for (var j = 0; j < rawData[i].length; j++) {
          rawDatas[i].push(rawData[i][j]);
        }
      }
      var categoryData = [];
      var values = [];
      var volumes = [];
      var input = [];
      var macd, kdj;
      var rsi1, rsi2, rsi3;
      var flageX = true;
      for (var i = 0; i < rawDatas.length; i++) {
        categoryData.push(rawDatas[i].splice(0, 1)[0]);
        // 判断是否大于40根K线,改变X轴刻度标签和提示值
        if (categoryData.length >= 40) {
          flageX = true;
          this.forty = function (val, index) {
            return val + "  " + val;
          };
          this.fortyX = null;
        } else {
          flageX = false;
          this.forty = function () {
            var num = categoryData.length - 1;
            return categoryData[num] + "  " + categoryData[0];
          };
          this.fortyX = function (val) {
            return categoryData[val.value - 1];
          };
        }
        values.push(rawDatas[i]);
        volumes.push([i, rawDatas[i][6], rawDatas[i][0] > rawDatas[i][1] ? 1 : -1]);
        input.push({
          open: rawDatas[i][0],
          close: rawDatas[i][1],
          low: rawDatas[i][4],
          high: rawDatas[i][5],
        });
      }
      // 判断是否大于40根K线 改变X轴
      if (flageX) {
        this.fortyEnd = 100;
        this.fortyendValue = null;
        this.categoryData = categoryData;
      } else {
        this.fortyEnd = null;
        this.fortyendValue = 40;
        this.startValues = 0;
        this.categoryData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40];
      }
      this.values = values;
      this.volumes = volumes;
      if (input.length > 0) {
        macd = this.calcMACD(12, 26, 9, input, "close");
        kdj = this.calcKDJ(9, 3, 3, input);
        rsi1 = this.calcRSI(6, input, "close");
        rsi2 = this.calcRSI(12, input, "close");
        rsi3 = this.calcRSI(24, input, "close");
        if (this.normLine == 0) {
          this.macds = macd.macd;
          this.difs = macd.dif;
          this.deas = macd.dea;
        } else if (this.normLine == 1) {
          this.macds = rsi3;
          this.difs = rsi1;
          this.deas = rsi2;
        } else if (this.normLine == 2) {
          this.macds = kdj.j;
          this.difs = kdj.k;
          this.deas = kdj.d;
        }
      }
    },

    calculateMA(dayCount, data) {
      var result = [];
      for (var i = 0, len = data.length; i < len; i++) {
        if (i < dayCount) {
          result.push("-");
          continue;
        }
        var sum = 0;
        for (var j = 0; j < dayCount; j++) {
          sum += data[i - j][1];
        }
        result.push((sum / dayCount).toFixed(3));
      }
      return result;
    },

    //分时图坐标轴
    datumAxis(target, done) {
      let that = this;
      that.xdata = [];
      front.getKbarTimeSeq2({
        targetId: target,
        ktype: front.ktype_minute,
        kunit: 1,
        resolve: function (rsp) {
          const list = rsp && Array.isArray(rsp.timeSeqList) ? rsp.timeSeqList : [];
          that._flashTimeSeqList = list;
          that._flashAxisTarget = target;
          that.valueAxis = list.length ? list[list.length - 1].seq : 0;
          that.xLabel = function (val) {
            for (var i = 0; i < list.length; i++) {
              if (val == list[i].seq) {
                if (i == 0 || i == list.length - 1) {
                  return list[i].time + "  " + list[i].time;
                } else {
                  return list[i].time;
                }
              }
            }
            return "";
          };
          for (var i = -1; i < that.valueAxis + 2; i++) {
            that.xdata.push(i);
          }
          const chart = that.getMain1Chart();
          if (chart) {
            chart.clear();
            chart.setOption(that.option1, true);
          }
          that.control = false;
          if (typeof done === "function") done();
        },
      });
    },

    //取消订阅分时图
    callOf(title) {
      var kreq = { targetId: title, ktype: front.ktype_minute, kunit: 1 };
      front.unsubKbar2(kreq, "market-flash");
      front.unsubTick(title, "market-datail");
    },

    //分时图
    loadingData(title, ktype, minute, opt) {
      var that = this;
      const silent = opt && opt.silent;
      const prefilled = opt && opt.prefilled;
      const quoteOnly = opt && opt.quoteOnly;
      const token = ++that._flashLoadToken;
      that._flashGapFixCount = opt && typeof opt._gapFix === "number" ? opt._gapFix : 0;
      if (!silent) that.showLoading = true;
      that.dataLoad = false;
      if (!prefilled) {
        that.optionSer1 = [];
        that.averagePrice = [];
        that.tooltipArr = [];
        that.optionSer2 = [];
        that.compare = null;
        const chart = that.getMain1Chart();
        if (chart) {
          chart.clear();
          chart.setOption(that.option1, true);
        }
      }
      var kreq = {
        targetId: title,
        ktype: ktype,
        kunit: minute,
        kquery: front.kquery_days,
        ksize: 1,
      };
      //改变上面数据和下拉数据的颜色
      front.subTick(title, {
        suberId: "market-datail",
        publish: function (quote) {
          // console.log(quote);
          const bitFromFront = front.getTargetPrecision(that.title);
          const bitFromTick = quote && quote.priceTick !== undefined ? art.digit(Number(quote.priceTick)) : NaN;
          const bit = Number.isFinite(bitFromTick) && bitFromTick > 0 ? bitFromTick : bitFromFront;
          if (Number.isFinite(bit) && bit >= 0) that.decimals = bit;

          if (that.flage_s) {
            that.downLowpro = Number(quote.lowPrice);
            that.downColse = Number(quote.lastSettlementPrice);
            that.downHight = that.downColse + (that.downColse - that.downLowpro);
            that.Ymax = Number(that.downHight);
            that.Ymin = that.downLowpro;
            that.Yinterval = (that.Ymax - that.downColse) / 2;
            that.flage_s = false;
            // console.log(that.Ymax)
          }
          that.oldPrice = that.newPrice; //保存前一个最新价
          // 下拉数据
          that.timeImforFlag = false;
          that.timeImfor_bottom.buyPro.pro = that.formatPrice(quote.bidPrice1);
          that.timeImfor_bottom.limitStop.pro = that.formatPrice(quote.highStopPrice);
          that.timeImfor_bottom.limitDown.pro = that.formatPrice(quote.lowStopPrice);
          that.timeImfor_bottom.hightPro.pro = that.formatPrice(quote.highPrice);
          that.timeImfor_bottom.sellPro.pro = that.formatPrice(quote.askPrice1);
          that.timeImfor_bottom.lowPro.pro = that.formatPrice(quote.lowPrice);
          // that.timeImfor_bottom.buyNum.pro = quote.bidVolume1;
          that.timeImfor_bottom.buyPro.buy = quote.bidVolume1;
          that.timeImfor_bottom.sellPro.buy = quote.askVolume1;
          // that.timeImfor_bottom.sellNum.pro = quote.askVolume1;
          // that.timeImfor.hand.pro = '--%';
          // that.timeImfor.position.pro = quote.position;
          if (((quote.highPrice - quote.lowPrice) / quote.lowPrice) * 100) {
            that.timeImfor.range.pro = (((quote.highPrice - quote.lowPrice) / quote.lowPrice) * 100).toFixed(2) + "%";
          } else {
            that.timeImfor.range.pro = "0.00%";
          }
          that.timeImfor.yesterday.pro = that.formatPrice(quote.lastClosePrice);
          // console.log(quote)
          //顶部数据
          // console.log(quote.latestPrice,quote.lastSettlementPrice*100,((quote.latestPrice*100).toFixed(0)-(quote.lastSettlementPrice*100).toFixed(0))/100)
          that.ranges =
            ((quote.latestPrice * 100).toFixed(0) - (quote.lastSettlementPrice * 100).toFixed(0)) / 100 > 0
              ? "+" + ((quote.latestPrice * 100).toFixed(0) - (quote.lastSettlementPrice * 100).toFixed(0)) / 100
              : ((quote.latestPrice * 100).toFixed(0) - (quote.lastSettlementPrice * 100).toFixed(0)) / 100;
          that.limit =
            ((quote.latestPrice - quote.lastSettlementPrice) * 100) / quote.lastSettlementPrice > 0
              ? "+" + (((quote.latestPrice - quote.lastSettlementPrice) * 100) / quote.lastSettlementPrice).toFixed(2)
              : (((quote.latestPrice - quote.lastSettlementPrice) * 100) / quote.lastSettlementPrice).toFixed(2);
          if (!that.dataflage) {
            that.open = that.formatPrice(quote.openPrice);
            that.turnover = quote.volume;
            that.number = quote.position;
          }
          that.newPrice = that.formatPrice(quote.latestPrice);
          that.close = that.formatPrice(quote.lastSettlementPrice);

          // 涨停价颜色变化
          if (Number(quote.highStopPrice) == Number(quote.lastSettlementPrice)) {
            that.stop_colorg = false;
            that.stop_colorr = false;
          } else if (Number(quote.highStopPrice) > Number(quote.lastSettlementPrice)) {
            that.stop_colorg = false;
            that.stop_colorr = true;
          } else if (Number(quote.highStopPrice) < Number(quote.lastSettlementPrice)) {
            that.stop_colorg = true;
            that.stop_colorr = false;
          }

          // 跌停价颜色变化
          if (Number(quote.lowStopPrice) == Number(quote.lastSettlementPrice)) {
            that.down_colorg = false;
            that.down_colorr = false;
          } else if (Number(quote.lowStopPrice) > Number(quote.lastSettlementPrice)) {
            that.down_colorg = false;
            that.down_colorr = true;
          } else if (Number(quote.lowStopPrice) < Number(quote.lastSettlementPrice)) {
            that.down_colorg = true;
            that.down_colorr = false;
          }

          //申买价颜色变化
          if (Number(quote.bidPrice1) == Number(quote.lastSettlementPrice)) {
            that.br_color = false;
            that.bg_color = false;
          } else if (Number(quote.bidPrice1) > Number(quote.lastSettlementPrice)) {
            that.br_color = true;
            that.bg_color = false;
          } else if (Number(quote.bidPrice1) < Number(quote.lastSettlementPrice)) {
            that.br_color = false;
            that.bg_color = true;
          }

          //申卖价颜色变化
          if (Number(quote.askPrice1) == Number(quote.lastSettlementPrice)) {
            that.sr_color = false;
            that.sg_color = false;
          } else if (Number(quote.askPrice1) > Number(quote.lastSettlementPrice)) {
            that.sr_color = true;
            that.sg_color = false;
          } else if (Number(quote.askPrice1) < Number(quote.lastSettlementPrice)) {
            that.sr_color = false;
            that.sg_color = true;
          }

          //最高价颜色变化
          if (Number(quote.highPrice) == Number(quote.lastSettlementPrice)) {
            that.h_color = false;
            that.hColor = false;
          } else if (Number(quote.highPrice) > Number(quote.lastSettlementPrice)) {
            that.h_color = true;
            that.hColor = false;
          } else if (Number(quote.highPrice) < Number(quote.lastSettlementPrice)) {
            that.h_color = false;
            that.hColor = true;
          }

          //最低价颜色变化
          if (Number(quote.lowPrice) == Number(quote.lastSettlementPrice)) {
            that.l_color = false;
            that.lColor = false;
          } else if (Number(quote.lowPrice) > Number(quote.lastSettlementPrice)) {
            that.l_color = true;
            that.lColor = false;
          } else if (Number(quote.lowPrice) < Number(quote.lastSettlementPrice)) {
            that.l_color = false;
            that.lColor = true;
          }

          //开盘价颜色变化
          if (Number(that.open) == Number(quote.lastSettlementPrice)) {
            that.open_color = false;
            that.open_color2 = false;
          } else if (Number(that.open) > Number(quote.lastSettlementPrice)) {
            that.open_color = true;
            that.open_color2 = false;
          } else if (Number(that.open) < Number(quote.lastSettlementPrice)) {
            that.open_color = false;
            that.open_color2 = true;
          }

          //判断行情,更换顶部字体颜色
          if (Number(quote.latestPrice) == Number(quote.lastSettlementPrice)) {
            that.c_red = false;
            that.c_green = false;
            that.c_grey = true;
          } else if (Number(quote.latestPrice) > Number(quote.lastSettlementPrice)) {
            that.c_red = true;
            that.c_green = false;
            that.c_grey = false;
          } else if (Number(quote.latestPrice) < Number(quote.lastSettlementPrice)) {
            that.c_red = false;
            that.c_green = true;
            that.c_grey = false;
          }
          // @huang.z.d 去除到闪烁的效果，晃眼
          //顶部最新价变化颜色
          // if (that.newPrice > that.oldPrice) {
          //   that.$refs.back.style.backgroundColor = "#ac2929";
          //   setTimeout(() => {
          //     that.$refs.back.style.backgroundColor = "";
          //   }, 1000);
          // } else if (that.newPrice < that.oldPrice) {
          //   that.$refs.back.style.backgroundColor = "#0eca1d";
          //   setTimeout(() => {
          //     that.$refs.back.style.backgroundColor = "";
          //   }, 1000);
          // } else {
          //   that.$refs.back.style.backgroundColor = "";
          // }
        },
      });
      if (quoteOnly) {
        if (!silent) that.showLoading = false;
        return;
      }
      front.subKbar2(kreq, {
        suberId: "market-flash",
        reject: function (error) {
          if (error) {
            that.showLoading = false;
            // console.log(error);
            // console.log("error");
            that.errorMessage = error.message;
            const chart = that.getMain1Chart();
            if (chart) {
              chart.clear();
              chart.setOption(that.option1, true);
            }
            that._fixFlashGap(title, token, true);
          }
        },
        publish: function (pub, type) {
          if (art.hasValue(type, art.content_head)) {
            that.optionSer1 = [];
            that.averagePrice = [];
            that.tooltipArr = [];
            that.optionSer2 = [];
            that.compare = null;
          }
          if (pub.kseq != that.compare) {
            // that.allArr.push(pub);
            that.optionSer1.push([pub.kseq, pub.priceClose]);
            that.averagePrice.push([pub.kseq, pub.priceAverage]);
            that.tooltipArr.push({
              num: pub.kseq,
              time: pub.time,
              priceClose: pub.priceClose,
              priceAverage: pub.priceAverage,
              volume: pub.volume,
              position: pub.position != null ? pub.position : pub.openInterest,
            });
            that.optionSer2.push({
              value: [pub.kseq, pub.volume],
              itemStyle: { color: "red" },
            });
            // that.option1.series[2].data.push([pub.kseq,pub.priceClose]);//暂时折线图数据, 具体算法未知
          } else {
            // that.allArr.splice(that.allArr.length - 1, 1, pub);
            that.optionSer1.splice(that.optionSer1.length - 1, 1, [pub.kseq, pub.priceClose]);
            that.averagePrice.splice(that.averagePrice.length - 1, 1, [pub.kseq, pub.priceAverage]);
            that.tooltipArr.splice(that.tooltipArr.length - 1, 1, {
              num: pub.kseq,
              time: pub.time,
              priceClose: pub.priceClose,
              priceAverage: pub.priceAverage,
              volume: pub.volume,
              position: pub.position != null ? pub.position : pub.openInterest,
            });
            that.optionSer2.splice(that.optionSer2.length - 1, 1, {
              value: [pub.kseq, pub.volume],
              itemStyle: { color: "red" },
            });
          }

          // Y轴坐标
          let priceClose = Number(pub.priceClose);
          if (priceClose < that.downLowpro) {
            that.downLowpro = priceClose;
            that.downHight = that.downColse + (that.downColse - that.downLowpro);
          } else if (priceClose > that.downHight) {
            that.downHight = priceClose;
            that.downLowpro = that.downColse - (that.downHight - that.downColse);
          }

          that.Ymax = Number(that.downHight);
          that.Ymin = Number(that.downLowpro);
          that.Yinterval = (that.Ymax - that.downColse) / 2;
          // console.log(that.Ymax)
          if (that.optionSer2.length > 1) {
            if (that.optionSer2[that.optionSer2.length - 1].value[1] > that.optionSer2[that.optionSer2.length - 2].value[1]) {
              that.optionSer2[that.optionSer2.length - 1].itemStyle.color = "red";
            } else {
              that.optionSer2[that.optionSer2.length - 1].itemStyle.color = "#2AE1FF";
            }
          }
          if (that.dataLoad) {
            that._scheduleFlashRender();
          }
          that.compare = pub.kseq;
          if (art.hasValue(type, art.content_last)) {
            (that.errorMessage = ""), (that.dataLoad = true);
            const chart = that.getMain1Chart();
            if (chart) {
              chart.clear();
              chart.setOption(that.option1, true);
              that.bindFlashTooltipBehavior();
              that.restoreFlashTooltip();
            }
            that._fixFlashGap(title, token, false);
            setTimeout(() => {
              that.showLoading = false;
            }, 10);
          }
          // that.option1.tooltip.formatter = function(param) {
          //   var param = param[0];
          //   for (var i = 0; i < that.tooltipArr.length; i++) {
          //     if (param.data[0] == that.tooltipArr[i].num) {
          //       return that.tooltipArr[i].time + "<br/> " + param.data[1];
          //     }
          //   }
          // };
        },
      });
    },

    //计算MACD , DIF , DEA
    calcEMA(n, data, field) {
      var i, l, ema, a;
      a = 2 / (n + 1);
      if (field) {
        ema = [data[0][field]];
        for (i = 1, l = data.length; i < l; i++) {
          ema.push(a * data[i][field] + (1 - a) * ema[i - 1]);
        }
      } else {
        ema = [data[0]];
        for (i = 1, l = data.length; i < l; i++) {
          ema.push(a * data[i] + (1 - a) * ema[i - 1]);
        }
      }
      return ema;
    },
    // * 计算DIF快线，用于MACD
    calcDIF(short, long, data, field) {
      var i, l, dif, emaShort, emaLong;
      dif = [];
      emaShort = this.calcEMA(short, data, field);
      emaLong = this.calcEMA(long, data, field);
      for (i = 0, l = data.length; i < l; i++) {
        dif.push(emaShort[i] - emaLong[i]);
      }
      return dif;
    },
    // 计算DEA慢线，用于MACD
    calcDEA(mid, dif) {
      return this.calcEMA(mid, dif);
    },
    //* 计算MACD
    calcMACD(short, long, mid, data, field) {
      var i, l, dif, dea, macd, result;
      result = {};
      macd = [];
      dif = this.calcDIF(short, long, data, field);
      dea = this.calcDEA(mid, dif);
      for (i = 0, l = data.length; i < l; i++) {
        macd.push((dif[i] - dea[i]) * 2);
      }
      result.dif = dif;
      result.dea = dea;
      result.macd = macd;
      return result;
    },

    // RSI
    calcRSI(n, data, field) {
      var arr = [0];
      var num1 = 0,
        num2 = 0,
        a = 0,
        b = 0;
      for (var i = 1; i < data.length; i++) {
        var RS = 0;
        if (data[i][field] < data[i - 1][field]) {
          a = (num1 * (n - 1)) / n + (data[i - 1][field] - data[i][field]) / n;
          b = (num2 * (n - 1)) / n;
        } else {
          b = (num2 * (n - 1)) / n + (data[i][field] - data[i - 1][field]) / n;
          a = (num1 * (n - 1)) / n;
        }
        num1 = a;
        num2 = b;
        RS = b / a;
        if (RS === Infinity) {
          RS = 1;
        }
        arr.push((RS / (1 + RS)) * 100);
      }
      return arr;
    },

    //   计算KDJ值;;;;;;;;;;;;;;;;;;
    calcLLV(pos, n, data, field) {
      var i, l, min;
      n--;
      min = data[pos][field];
      l = pos - n;
      l < 0 ? (l = 0) : 1;
      for (i = pos; i >= l; i--) {
        if (min > data[i][field]) {
          min = data[i][field];
        }
      }
      return min;
    },
    // 计算最大值
    calcHHV(pos, n, data, field) {
      var i, l, max;
      n--;
      max = data[pos][field];
      l = pos - n;
      l < 0 ? (l = 0) : 1;
      for (i = pos; i >= l; i--) {
        if (max < data[i][field]) {
          max = data[i][field];
        }
      }
      return max;
    },
    // 计算SMA，加权移动平均指标
    calcSMA(n, m, data) {
      var i, l, sma;
      sma = [100];
      for (i = 1, l = data.length; i < l; i++) {
        sma.push((data[i] * m + sma[i - 1] * (n - m)) / n);
      }
      return sma;
    },
    // 计算RSV，未成熟随机值指标
    calcRSV(n, data) {
      var i, l, rsv, low, tempValue;
      rsv = [];
      for (i = 0, l = data.length; i < l; i++) {
        low = this.calcLLV(i, n, data, "low");
        tempValue = (100 * (data[i].close - low)) / (this.calcHHV(i, n, data, "high") - low);
        if (isNaN(tempValue)) {
          if (i === 0) {
            tempValue = 100;
          } else {
            tempValue = rsv[i - 1];
          }
        }
        rsv.push(tempValue);
      }
      return rsv;
    },
    // 计算KDJ
    calcKDJ(n, m1, m2, data) {
      var i, l, rsv, k, d, j;
      rsv = this.calcRSV(n, data);
      k = this.calcSMA(m1, 1, rsv);
      d = this.calcSMA(m2, 1, k);
      j = [];
      for (i = 0, l = k.length; i < l; i++) {
        j.push(3 * k[i] - 2 * d[i]);
      }
      return {
        k: k,
        d: d,
        j: j,
      };
    },
  },
  mounted() {
    this.syncHeaderLayout();
    this.$nextTick(() => {
      this.syncChartSize();
    });

    if (!this._resizeHandler) {
      this._resizeHandler = () => this.syncChartSize();
      window.addEventListener("resize", this._resizeHandler);
    }

    ///K线图拖动,缩放 数据变化
    const main3Chart = this.getMain3Chart();
    if (!main3Chart) return;
    main3Chart.on(
      "datazoom",
      function (val) {
        // 滑动到最左, 懒加载
        if (val.batch[0].start == 0) {
          this.lazyLoad = true;
          this.endPercent = val.batch[0].end;
        } else {
          this.lazyLoad = false;
        }
        // console.log(val)
        // console.log(echarts.init(document.getElementById('main3')));

        //控制两指缩放时触发坐标轴标线
        this.twoFingers = false;

        //控制MA值的值是根据拖动变化还是根据数据更新变化
        this.ma_flage = false;
        if (val.batch[0].end == 100) {
          this.ma_flage = true;
        }
        var inst = this.getMain3Chart();
        var data = inst ? inst._chartsMap : null;
        if (!data) return;
        let u_ma5 = unescape("_ec_%00MA5%000_series.line");
        let u_ma10 = unescape("_ec_%00MA10%000_series.line");
        let u_ma20 = unescape("_ec_%00MA20%000_series.line");
        let u_ma60 = unescape("_ec_%00MA60%000_series.line");
        let u_volume = unescape("_ec_%00Volume%000_series.bar");
        let u_dif = unescape("_ec_%00DIF%000_series.line");
        let u_dea = unescape("_ec_%00DEA%000_series.line");
        let u_macd;
        if (this.targetflage) {
          u_macd = unescape("_ec_%00MACD%000_series.bar");
        } else {
          u_macd = unescape("_ec_%00MACD%000_series.line");
        }
        //   // 柱状折线
        // let u_line = unescape("_ec_%00Line%000_series.line");
        // console.log(data);
        this.num1 = "0.00";
        this.num2 = "0.00";
        this.num3 = "0.00";
        this.num4 = "0.00";
        this.num5 = "0.00";
        this.num6 = "0.00";
        this.numMACD = "0.00";
        this.numDIF = "0.00";
        this.numDEA = "0.00";
        // console.log(data[u_ma5].__model.parentModel.option.dataZoom[1].endValue);
        // console.log(data[u_ma5].__model.option.data[data[u_ma5].__model.parentModel.option.dataZoom[1].endValue])
        if (Number.isFinite(data[u_ma5]._data._extent.y[1]) && !isNaN(data[u_ma5].__model.option.data[data[u_ma5].__model.parentModel.option.dataZoom[1].endValue])) {
          this.num1 = data[u_ma5].__model.option.data[data[u_ma5].__model.parentModel.option.dataZoom[1].endValue];
        }
        if (Number.isFinite(data[u_ma10]._data._extent.y[1]) && !isNaN(data[u_ma10].__model.option.data[data[u_ma10].__model.parentModel.option.dataZoom[1].endValue])) {
          this.num2 = data[u_ma10].__model.option.data[data[u_ma10].__model.parentModel.option.dataZoom[1].endValue];
        }
        if (Number.isFinite(data[u_ma20]._data._extent.y[1]) && !isNaN(data[u_ma20].__model.option.data[data[u_ma20].__model.parentModel.option.dataZoom[1].endValue])) {
          this.num3 = data[u_ma20].__model.option.data[data[u_ma20].__model.parentModel.option.dataZoom[1].endValue];
        }
        if (Number.isFinite(data[u_ma60]._data._extent.y[1]) && !isNaN(data[u_ma60].__model.option.data[data[u_ma60].__model.parentModel.option.dataZoom[1].endValue])) {
          this.num4 = data[u_ma60].__model.option.data[data[u_ma60].__model.parentModel.option.dataZoom[1].endValue];
        }
        if (Number.isFinite(data[u_volume]._data._extent.y[1])) {
          this.num5 = data[u_volume].__model.option.data[data[u_volume].__model.parentModel.option.dataZoom[1].endValue][1];
        }
        if (Number.isFinite(data[u_dif]._data._extent.y[1])) {
          this.numDIF = data[u_dif].__model.option.data[data[u_dif].__model.parentModel.option.dataZoom[1].endValue];
        }
        if (Number.isFinite(data[u_dea]._data._extent.y[1])) {
          this.numDEA = data[u_dea].__model.option.data[data[u_dea].__model.parentModel.option.dataZoom[1].endValue];
        }
        if (Number.isFinite(data[u_macd]._data._extent.y[1])) {
          this.numMACD = data[u_macd].__model.option.data[data[u_macd].__model.parentModel.option.dataZoom[1].endValue];
        }
        //   // 柱状折线
        // if (data[u_line]._data._extent.y[1] != "-Infinity") {
        //   this.num6 =
        //     data[u_line].__model.option.data[
        //       data[u_line].__model.parentModel.option.dataZoom[1].endValue
        //     ][1];
        // }
      }.bind(this)
    );
  },
  activated() {
    const routeContract = this.$route && this.$route.params ? this.$route.params.contract : "";
    const currentView = this.select_k || 1;
    const handledByWatch = routeContract && this._routeContractHandledByWatch === routeContract;
    this.showLazyLoad = false;
    this.flage_s = true;
    this.appear_share = false;
    this.nowTypes = 1;
    this.flage = true;
    this.select_k = currentView;
    this._suppressNextRouteContractWatch = this.title !== routeContract;
    this.title = routeContract;
    this.decimals = front.getTargetPrecision(this.title);
    this.refreshSelfIcon();
    if (handledByWatch) {
      this._routeContractHandledByWatch = "";
      this.subscribeDominantTargets();
      this.$nextTick(() => {
        this.syncChartSize();
      });
      return;
    }
    if (currentView === 1) {
      this.nowType = 1;
      this.handIcap = true;
      this.control = true;
      this.cancel(this.title, this.kType, this.typeNum);
      this.kType = front.ktype_minute;
      this.callOf(this.title);
      this.datumAxis(this.title, () => {
        this.loadingData(this.title, front.ktype_minute, 1);
      });
    } else {
      this.nowType = 3;
      this.handIcap = false;
      this.MacdFlage = true;
      this.cancel(this.title, this.kType, this.typeNum);
      this.callOf(this.title);
      if (currentView === 2) {
        this.minuteK(this.save_num1);
      } else if (currentView === 3) {
        this.oneLine(this.title, front.ktype_day, 1);
        this.kType = front.ktype_day;
        this.typeNum = 1;
      } else if (currentView === 4) {
        this.weekK(this.save_num2);
      } else {
        this.minuteK(this.save_num1);
      }
    }
    this.subscribeDominantTargets();
    this.$nextTick(() => {
      this.syncChartSize();
    });
  },
  //退出定阅页面事件
  deactivated: function () {
    if (this._flashRenderTimer) {
      clearTimeout(this._flashRenderTimer);
      this._flashRenderTimer = null;
    }
    if (this._klineRenderTimer) {
      clearTimeout(this._klineRenderTimer);
      this._klineRenderTimer = null;
    }
    front.dominantTargetUnsub(this.dominantSuberId);
    this.dominantSubscribed = false;
    this.dominantTargetMap = {};
    this.cancel(this.title, this.kType, this.typeNum);
    this.callOf(this.title);
    this.rowData = [];
    this.volumes = [];
    this.optionSer1 = [];
    this.averagePrice = [];
    this.optionSer2 = [];
    this.option1.series[2].data = [];
    this.toolArrs = [];
    this.showLoading = false;
    this.tooltipArr = [];
    // front.unsubTick(this.title, "market-detail");
    // 数据还原
    this.open = "0";
    this.turnover = "0";
    this.number = "0";
    this.newPrice = "0";
    this.close = "0";
    this.ranges = "0";
    this.limit = "0.00";
    (this.timeImfor_bottom = {
      sellPro: {
        tit: "卖一",
        pro: "0.00",
        buy: 0,
      },
      hightPro: {
        tit: "最高",
        pro: "0.00",
      },
      limitStop: {
        tit: "涨停",
        pro: "0.00",
      },
      buyPro: {
        tit: "买一",
        pro: "0.00",
        buy: 0,
      },
      lowPro: {
        tit: "最低",
        pro: "0.00",
      },
      limitDown: {
        tit: "跌停",
        pro: "0.00",
      },
    }),
      (this.Yinterval = 0);
    this.Ymin = 0;
    this.Ymax = 0;
    // 颜色还原
    //>最高价,最低价
    this.c_red = false;
    this.c_green = false;
    this.c_grey = false;
    this.h_color = false;
    this.l_color = false;
    this.hColor = false;
    this.lColor = false;
    //>开盘价
    this.open_color = false;
    this.open_color2 = false;
    //>申买价,申卖价
    this.br_color = false;
    this.bg_color = false;
    this.sr_color = false;
    this.sg_color = false;
    //>涨停价,跌停价
    this.stop_colorg = false;
    this.stop_colorr = false;
    this.down_colorg = false;
    this.down_colorr = false;
  },
};
</script>
<style scoped>
.showLazyLoad,
.nonData {
  width: 2rem;
  height: 0.5rem;
  line-height: 0.5rem;
  text-align: center;
  position: absolute;
  top: 2.5rem;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 9999;
  background: rgba(200, 200, 200, 0.1);
  font-size: 0.2rem;
  color: #ccc;
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 0.45rem;
  font-style: normal;
  /*font-weight: bold;*/
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  color: #797b7d;
}

.top-wrapper {
  font-size: 0.3rem;
  color: #797b7d;
  position: absolute;
  top: 1rem;
  bottom: 1rem;
  overflow: hidden;
  width: 100%;
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
  display: flex;
  flex-direction: column;
}

.top {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  /* height: 1.24rem; */
  height: 2.2rem;
  background-color: #1c1d2f;
  border-top: 0.02rem solid #0f1022;
  border-bottom: 0.04rem solid #0f1022;
  flex: 0 0 2.2rem;
}

.top-left {
  width: 0;
  height: 100%;
  overflow: hidden;
}

.top-middle {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
}
.headerWrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 1rem;
  padding: 0 1.2rem;
  box-sizing: border-box;
  text-align: center;
  background: linear-gradient(90deg, #111822 0%, #141b1f 100%);
  color: #f4f7fb;
  font-size: 0.36rem;
  font-weight: 600;
  letter-spacing: 0.01rem;
  border-bottom: 1px solid rgba(58, 68, 82, 0.9);
  box-shadow: 0 0.06rem 0.18rem rgba(0, 0, 0, 0.16);
}
.left {
  position: absolute;
  left: 0.16rem;
  top: 50%;
  transform: translateY(-50%);
  width: 0.72rem;
  text-align: center;
  font-size: 0.34rem;
  color: #d9e2ec;
}

.right {
  position: absolute;
  right: 0.16rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.34rem;
  color: #d9e2ec;
  width: 0.6rem;
  text-align: right;
}

.right2 {
  position: absolute;
  right: 0.78rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.34rem;
  color: #d9e2ec;
  width: 0.6rem;
  text-align: right;
}

.header-center {
  position: absolute;
  left: 0.86rem;
  right: 1.46rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.1rem;
  width: auto;
  min-width: 0;
  padding: 0;
  box-sizing: border-box;
}

.contract-switch-arrow {
  position: static;
  width: 0.36rem;
  flex: 0 0 0.36rem;
  font-size: 0.44rem;
  line-height: 1;
  text-align: center;
  color: #fff;
  user-select: none;
  z-index: 1;
}

.contract-switch-arrow-prev {
  margin-right: 0.02rem;
}

.contract-switch-arrow-next {
  margin-left: 0.02rem;
}
.contract-switch-arrow.disabled {
  opacity: 0.35;
}

.contract-names {
  min-width: 0;
  max-width: 2.8rem;
  flex: 0 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.1;
  gap: 0.06rem;
}

.contract-cn {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.32rem;
  line-height: 1.1;
}

.contract-en-line {
  max-width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.08rem;
}

.contract-en {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.24rem;
  line-height: 1.1;
  color: #d6d6d6;
}

.dominant-badge {
  flex: 0 0 auto;
  font-size: 0.2rem;
  line-height: 0.26rem;
  padding: 0 0.08rem;
  border-radius: 0.06rem;
  background: #ff9f00;
  color: #fff;
}

.c_grey {
  color: #acacac;
}
.c_red {
  color: #cd002f;
}
.c_green {
  color: #24b127;
}

.middle-first {
  display: block;
  /* height: 0.8rem; */
  height: auto;
  /* line-height: 0.8rem; */
  line-height: 1.1;
  width: 100%;
  text-align: center;
  font-size: 0.56rem;
  /* color: #24B127; */
  font-weight: bold;
}

.middle-two {
  /* color: #24B127; */
  width: 100%;
  /* height:0.48rem; */
  height: auto;
  /* line-height:0.48rem; */
  line-height: 1.1;
  font-weight: bold;
  font-size: 0.3rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.16rem;
}
.middle-two p {
  float: none;
  width: auto;
  height: auto;
  line-height: 1.1;
  text-align: center;
  margin: 0;
}
.two {
  text-align: center;
}

.top-right {
  flex: 0 0 4.1rem;
  width: 4.1rem;
  min-width: 0;
  /* height: 1.28rem; */
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: stretch;
  column-gap: 0.2rem;
  row-gap: 0.18rem;
  align-content: center;
  padding-right: 0.12rem;
  box-sizing: border-box;
}

.right-content {
  font-size: 0.25rem;
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  line-height: 1;
  min-width: 0;
  width: 100%;
}
.right-content span {
  float: none;
  white-space: nowrap;
}
.right-content .rc-label {
  flex: 0 0 auto;
  text-align: left;
  width: 0.9rem;
}
.right-content span:nth-child(2) {
  flex: 1 1 auto;
  min-width: 0;
  text-align: right;
  margin-left: 0.12rem;
}
.top-right .right-content .openColor {
  color: #cd002f;
}
.top-right .right-content .openColor2 {
  color: #24b127;
}

.right-content span:nth-child(2) {
  font-weight: bold;
  color: #acacac;
}

.two-top {
  height: 0.75rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  /* border-top: 1px solid #030507; */
  background-color: #141522;
  position: absolute;
  /* top: 1.3rem; */
  top: 10%;
  left: 0;
  z-index: 99;
  font-size: 0.25rem; /* 昨收盘和振幅字样大小优化 */
}
.two-top div {
  width: 30%;
  height: 0.75rem;
  line-height: 0.75rem;
}

.market-data {
  width: 33.3%;
  height: 0.75rem;
  line-height: 0.75rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-end;
}

.market-data span:nth-child(2) {
  font-weight: bold;
  color: #030507;
  width: 1rem;
  text-align: right;
}
.handicap .tcolor span:nth-child(2) {
  color: #cd002f;
}
.handicap .tcolor2 span:nth-child(2) {
  color: #cd002f;
}
.handicap .tcolor3 span:nth-child(2) {
  color: #24b127;
}
.handicap .tcolor4 span:nth-child(2) {
  color: #24b127;
}
.handicap .srcolor span:nth-child(2) {
  color: #cd002f;
}
.handicap .brcolor span:nth-child(2) {
  color: #cd002f;
}
.handicap .sgcolor span:nth-child(2) {
  color: #24b127;
}
.handicap .bgcolor span:nth-child(2) {
  color: #24b127;
}
.handicap .stopColorr span:nth-child(2) {
  color: #cd002f;
}
.handicap .downColorr span:nth-child(2) {
  color: #cd002f;
}
.handicap .stopColorg span:nth-child(2) {
  color: #24b127;
}
.handicap .downColorg span:nth-child(2) {
  color: #24b127;
}
.middle {
  position: relative;
  height: 1rem;
  width: 100%;
  background: #1c1d2f;
  font-size: 0.26rem;
  color: #acacac;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  left: 0;
  bottom: 0;
}

.middle .pardon {
  width: 60%;
  background-color: #0e0f21;
  height: 0.6rem;
  border-radius: 0.3rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.middle .pardon span {
  width: 1rem;
  height: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.06rem;
  line-height: 1;
  text-align: center;
  border-radius: 0.25rem;
  color: #cdcdcd;
  white-space: nowrap;
}
.middle .pardon .font_icon {
  margin-left: 0;
}
.font_icon {
  color: #cdcdcd;
  font-size: 0.26rem;
  margin-left: 0.1rem;
}
.slect_k {
  background-color: #488ef5;
}
.popus,
.MACDpopus {
  width: 100%;
  height: 0.8rem;
  position: absolute;
  top: -0.8rem;
  background-color: #131420;
  border-bottom: 1px solid #000;
  overflow: scroll;
  font-size: 0;
  z-index: 1000;
}
.popus div,
.MACDpopus div {
  display: inline-block;
  height: 0.8rem;
  width: auto;
  min-width: 100%;
  white-space: nowrap;
  overflow-x: scroll;
}
.popus div span,
.MACDpopus div span {
  color: #acacac;
  display: inline-block;
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.26rem;
  padding: 0 0.4rem;
  border-radius: 0.1rem;
}
.clickBackground {
  background-color: #000;
}
.ri_border {
  border-right: 1px solid #dddcdd;
}
.checked-type {
  background: #010101;
}
.k-wrapper1 {
  /* width: 7.5rem; */
  width: 100%;
  /* height: 8.3rem; */
  height: auto;
  background: #201d2e;
  flex: 1 1 auto;
  min-height: 0;
}
.k-wrapper2 {
  /* width: 7.5rem; */
  /* width: 100%; */
  /* height: 10.03rem; */
  /* height:80%; */
  overflow: hidden;
  height: auto;
  background: #201d2e;
  flex: 1 1 auto;
  min-height: 0;
}
.k-wrapper2 > div {
  overflow: hidden;
}
.k-wrapper2 canvas {
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  pointer-events: none;
}
.handicap {
  width: 100%;
  /* height: 1.73rem; */
  height: auto;
  flex: 0 0 1.9rem;
  background-color: #1d192e;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
}
.bottom-data {
  width: 24%;
  height: 49%;
  /* height: 0.75rem; */
  /* line-height: 0.75rem; */
  line-height: 1.2;
  font-size: 0.24rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  column-gap: 0.1rem;
  min-width: 0;
}
.bottom-data:nth-child(-n + 3) {
  transform: translateY(0.3rem);
}
.bottom-data:nth-child(1),
.bottom-data:nth-child(4) {
  width: 33%;
}
.bottom-data:nth-child(1) span,
.bottom-data:nth-child(4) span {
  width: 33%;
  text-align: center;
}
.bottom-data span:nth-child(2),
.bottom-data span:nth-child(3) {
  font-weight: bold;
  color: #acacac;
  /* width: 0.9rem; */
  text-align: right;
}
.bottom-data .bd-label,
.bottom-data .bd-value,
.bottom-data .bd-buy {
  white-space: nowrap;
  min-width: 0;
}
.bottom-data .bd-label {
  flex: 0 0 auto;
}
.bottom-data .bd-value {
  flex: 1 1 auto;
  text-align: right;
  font-weight: bold;
  color: #acacac;
}
.bottom-data .bd-buy {
  flex: 0 0 auto;
  text-align: right;
  font-weight: bold;
  color: #acacac;
}
@media screen and (min-height: 50rem) {
  .k-wrapper {
    height: 11.93rem;
  }
}
.loading {
  width: 100%;
  position: absolute;
  top: 1rem;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}
.loading div {
  position: absolute;
  width: 1rem;
  height: 1rem;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.loading div img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/yj/marketDetail.vue